import React, { useContext, useState, useEffect, useRef } from "react";
import toast from "react-hot-toast";
import imageCompression from "browser-image-compression";
import { ThemeContext } from "../../hooks/ThemeContext";
import { UserContext } from "../../hooks/UserContext";
import { api } from "../../services/baseUrl";

import {
  Users,
  ShoppingBag,
  Mail,
  Settings,
  TrendingUp,
  DollarSign,
  Package,
  MessageSquare,
  BarChart3,
  Plus,
  Download,
  Filter,
  Palette,
  Eye,
  Edit,
  Trash2,
  X,
  Power,
  FolderKanban,
  FileText,
  Receipt,
  Calculator,
} from "lucide-react";
import TableAdmin from "../../components/admin/TableAdmin";
import ModalAdmin from "../../components/admin/ModalAdmin";
import SearchBar from "../../components/admin/SearchBar";
import Pagination from "../../components/admin/Pagination";
import MessagingAdmin from "../../components/admin/MessagingAdmin";
import Watermark from "../../components/common/Watermark";

function Dashboard() {
  const { theme } = useContext(ThemeContext);
  const { user, isAuthenticated } = useContext(UserContext);
  const isDark = theme === "dark";

  const [activeTab, setActiveTab] = useState("products");
  const [userSubTab, setUserSubTab] = useState("users");

  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [searchUser, setSearchUser] = useState("");
  const [currentPageUsers, setCurrentPageUsers] = useState(1);
  const [totalPagesUsers, setTotalPagesUsers] = useState(1);
  const [selectedUser, setSelectedUser] = useState(null);
  const [userModalOpen, setUserModalOpen] = useState(false);
  const [userFormMode, setUserFormMode] = useState("create");

  const [filteredOrders, setFilteredOrders] = useState([]);
  const [searchOrder, setSearchOrder] = useState("");
  const [currentPageOrders, setCurrentPageOrders] = useState(1);
  const [totalPagesOrders, setTotalPagesOrders] = useState(1);
  const [orderModalOpen, setOrderModalOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);

  const [messages, setMessages] = useState([]);
  const [filteredMessages, setFilteredMessages] = useState([]);
  const [searchMessage, setSearchMessage] = useState("");
  const [messageTypeFilter, setMessageTypeFilter] = useState("all");
  const [currentPageMessages, setCurrentPageMessages] = useState(1);
  const [totalPagesMessages, setTotalPagesMessages] = useState(1);
  const [messageModalOpen, setMessageModalOpen] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [replyText, setReplyText] = useState("");
  const [unreadMessagesCount, setUnreadMessagesCount] = useState(0);

  const [projects, setProjects] = useState([]);
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [searchProject, setSearchProject] = useState("");
  const [currentPageProjects, setCurrentPageProjects] = useState(1);
  const [totalPagesProjects, setTotalPagesProjects] = useState(1);
  const [projectModalOpen, setProjectModalOpen] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);
  const [projectFormMode, setProjectFormMode] = useState("create");
  // Pour les liens dynamiques du projet
  const [projectLinks, setProjectLinks] = useState([]);
  // Pour les images du projet
  const [projectImages, setProjectImages] = useState([]);

  const [products, setProducts] = useState([]);
  const [productsError, setProductsError] = useState(null);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [searchProduct, setSearchProduct] = useState("");
  const [productStatusTab, setProductStatusTab] = useState("all");
  const [productFilters, setProductFilters] = useState({
    saleType: "",
    status: "",
    creatorType: "",
    creatorId: "",
  });
  const [productSaleType, setProductSaleType] = useState("libre");
  const [allowedUsers, setAllowedUsers] = useState([]);
  const [currentPageProducts, setCurrentPageProducts] = useState(1);
  const [totalPagesProducts, setTotalPagesProducts] = useState(1);
  const [productModalOpen, setProductModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedAdminGalleryImage, setSelectedAdminGalleryImage] = useState(0);
  const [productFormMode, setProductFormMode] = useState("create");
  const [uploadedImages, setUploadedImages] = useState([]);
  const [imagePreviews, setImagePreviews] = useState([]);
  const [productFiles, setProductFiles] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [categoryModalOpen, setCategoryModalOpen] = useState(false);
  const [categoryFormMode, setCategoryFormMode] = useState("create");
  const [selectedCategoryData, setSelectedCategoryData] = useState(null);
  const fileInputRef = useRef(null);

  const [promoCodes, setPromoCodes] = useState([]);
  const [promoFlashId, setPromoFlashId] = useState(null);
  const [promoForm, setPromoForm] = useState({
    code: "",
    discount: "",
    start_date: "",
    end_date: "",
    id_product: "",
  });

  const [newsletterSubscribers, setNewsletterSubscribers] = useState([]);
  const [newsletterSearch, setNewsletterSearch] = useState("");
  const [siteSettings, setSiteSettings] = useState({
    maintenance_mode: false,
    blocked_roles: [],
  });
  const [siteSettingsLoading, setSiteSettingsLoading] = useState(false);
  const [siteSettingsSaving, setSiteSettingsSaving] = useState(false);

  const [creators, setCreators] = useState([]);
  const [filteredCreators, setFilteredCreators] = useState([]);
  const [searchCreator, setSearchCreator] = useState("");
  const [currentPageCreators, setCurrentPageCreators] = useState(1);
  const [totalPagesCreators, setTotalPagesCreators] = useState(1);
  const [creatorModalOpen, setCreatorModalOpen] = useState(false);
  const [selectedCreator, setSelectedCreator] = useState(null);
  const [creatorFormMode, setCreatorFormMode] = useState("create");
  const [creatorsList, setCreatorsList] = useState([]);
  const [uploadedCreatorImage, setUploadedCreatorImage] = useState(null);

  const [earningsData, setEarningsData] = useState([]);
  const [searchEarnings, setSearchEarnings] = useState("");
  const [filteredEarnings, setFilteredEarnings] = useState([]);
  const [currentPageEarnings, setCurrentPageEarnings] = useState(1);
  const [totalPagesEarnings, setTotalPagesEarnings] = useState(1);

  const [stats, setStats] = useState({
    users: 0,
    orders: 0,
    revenue: 0,
    ursaff: 0,
    messages: 0,
  });
  const [pricingPlans, setPricingPlans] = useState([
    { name: "Vitrine", price: 490, unit: "projet", installments: 3 },
    { name: "Pro", price: 990, unit: "projet", installments: 4 },
    { name: "E-commerce", price: 1490, unit: "projet", installments: 6 },
  ]);
  const [noCommitmentAmount, setNoCommitmentAmount] = useState(3000);
  const [hostingPriceLow, setHostingPriceLow] = useState(12);
  const [hostingPriceHigh, setHostingPriceHigh] = useState(15);
  const [pricingSaving, setPricingSaving] = useState(false);
  const [billingForm, setBillingForm] = useState({
    autoCreateUser: true,
    clientUserId: "",
    clientName: "",
    clientFirstname: "",
    clientLastname: "",
    clientEmail: "",
    serviceName: "Prestation web",
    description: "",
    formulaKey: "custom",
    amountHt: 0,
    tvaRate: 20,
    billingMode: "invoice", // invoice | monthly
    installments: 3,
    startDate: new Date().toISOString().slice(0, 10),
    dueDays: 7,
  });
  const [generatedDocument, setGeneratedDocument] = useState(null);
  const [billingSaving, setBillingSaving] = useState(false);
  const [adminBillingDocs, setAdminBillingDocs] = useState([]);
  const [adminBillingLoading, setAdminBillingLoading] = useState(false);
  const [adminBillingSubTab, setAdminBillingSubTab] = useState("quotes");

  // Livraisons (delivery files)
  const [deliveryFiles, setDeliveryFiles] = useState([]);
  const [deliveryFilesLoading, setDeliveryFilesLoading] = useState(false);
  const [deliveryUploading, setDeliveryUploading] = useState(false);
  const [deliveryForm, setDeliveryForm] = useState({ clientId: "", label: "", file: null });
  const deliveryFileInputRef = React.useRef(null);

  const itemsPerPage = 10;
  const currentUserId = user?.id_user ?? user?.id;
  const currentUserRole =
    user?.id_role ?? user?.role_id ?? user?.role?.id_role ?? user?.role;
  const defaultCreatorType = currentUserRole === 3 ? "krayne" : "external";
  const defaultCreatorId = currentUserRole === 2 ? currentUserId : null;
  const defaultCreatorName =
    currentUserRole === 3
      ? "Krayne Agency"
      : (user?.nickname ??
        (`${user?.firstname ?? ""} ${user?.lastname ?? ""}`.trim() ||
          "Créateur"));
  const formatCurrency = (value) => `${Number(value || 0).toFixed(2)}€`;
  const normalizeCategoryName = (value) =>
    String(value || "")
      .trim()
      .toLowerCase();
  const resolveSelectedCategoryValue = (productLike) => {
    if (!productLike) return "";

    const directValue =
      typeof productLike.category === "object"
        ? productLike.category?.name ||
          productLike.category?.name_category ||
          ""
        : productLike.category || productLike.category_name || "";

    if (directValue) {
      const matchedByName = categories.find((category) => {
        const categoryName = category?.name || category?.name_category || "";
        return (
          normalizeCategoryName(categoryName) ===
          normalizeCategoryName(directValue)
        );
      });

      if (matchedByName) {
        return matchedByName.name || matchedByName.name_category || "";
      }

      return directValue;
    }

    const categoryId =
      productLike.id_category ||
      productLike.category_id ||
      productLike.category?.id_category ||
      productLike.category?.id;

    if (!categoryId) {
      return "";
    }

    const matchedCategory = categories.find(
      (category) =>
        String(category.id_category || category.id) === String(categoryId),
    );
    return matchedCategory?.name || matchedCategory?.name_category || "";
  };

  const normalizeProductForForm = (productLike) => {
    if (!productLike) return null;

    return {
      ...productLike,
      id: productLike.id ?? productLike.id_product,
      id_product: productLike.id_product ?? productLike.id,
      name: productLike.name ?? productLike.name_product ?? "",
      description:
        productLike.description ?? productLike.description_product ?? "",
      price:
        productLike.price ??
        productLike.price_ht ??
        productLike.price_product ??
        "",
      price_ht:
        productLike.price_ht ??
        productLike.price ??
        productLike.price_product ??
        "",
      stock:
        productLike.stock ??
        productLike.available_stock ??
        productLike.quantity_product ??
        1,
      status: productLike.status ?? "active",
      sale_type: productLike.sale_type ?? "libre",
      creator_type: productLike.creator_type ?? defaultCreatorType,
      id_user_creator:
        productLike.id_user_creator ??
        productLike.creator?.id_user ??
        defaultCreatorId,
      creator_name:
        productLike.creator_name ??
        productLike.creator?.nickname ??
        defaultCreatorName,
      category:
        typeof productLike.category === "object"
          ? productLike.category?.name ||
            productLike.category?.name_category ||
            ""
          : productLike.category || productLike.category_name || "",
      allowed_users: Array.isArray(productLike.allowed_users)
        ? productLike.allowed_users
        : [],
      downloadable_files: Array.isArray(productLike.downloadable_files)
        ? productLike.downloadable_files
        : [],
      images: Array.isArray(productLike.images) ? productLike.images : [],
      is_featured: productLike.is_featured ?? false,
      id_user_client: productLike.id_user_client ?? null,
      link:
        productLike.link ??
        productLike.project_url ??
        productLike.project_link ??
        "",
    };
  };

  const amountHt = Number(billingForm.amountHt || 0);
  const tvaRate = Number(billingForm.tvaRate || 0);
  const tvaAmount = amountHt * (tvaRate / 100);
  const amountTtc = amountHt + tvaAmount;
  const installmentsCount = Math.max(1, Number(billingForm.installments || 1));
  const monthlyAmount =
    installmentsCount > 1
      ? Math.ceil(amountTtc / installmentsCount)
      : amountTtc;

  const billingFormulaOptions = [
    { key: "custom", label: "Personnalisé" },
    ...pricingPlans.flatMap((plan) => [
      {
        key: `${plan.name}-cash`,
        label: `${plan.name} (cash)`,
        mode: "invoice",
        installments: 1,
        totalTtc: Number(plan.price || 0),
        serviceName: `Site ${plan.name}`,
      },
      {
        key: `${plan.name}-monthly`,
        label: `${plan.name} (mensuel)`,
        mode: "monthly",
        installments: Math.max(1, Number(plan.installments || 1)),
        totalTtc: Number(plan.price || 0),
        serviceName: `Site ${plan.name}`,
      },
    ]),
    {
      key: "sans-engagement-cash",
      label: "Sans engagement (cash)",
      mode: "invoice",
      installments: 1,
      totalTtc: Number(noCommitmentAmount || 0),
      serviceName: "Site web sans engagement",
    },
  ];

  const applyBillingFormula = (formulaKey) => {
    const selected = billingFormulaOptions.find((f) => f.key === formulaKey);

    if (!selected || formulaKey === "custom") {
      setBillingForm((p) => ({ ...p, formulaKey: formulaKey || "custom" }));
      return;
    }

    const currentTvaRate = Number(billingForm.tvaRate || 20);
    const totalTtc = Number(selected.totalTtc || 0);
    const computedHt =
      currentTvaRate > 0
        ? Number((totalTtc / (1 + currentTvaRate / 100)).toFixed(2))
        : totalTtc;

    setBillingForm((p) => ({
      ...p,
      formulaKey,
      serviceName: selected.serviceName || p.serviceName,
      amountHt: computedHt,
      billingMode: selected.mode || p.billingMode,
      installments:
        selected.mode === "monthly"
          ? Math.max(1, Number(selected.installments || p.installments || 1))
          : 1,
    }));
  };

  const generateBillingDocument = async (type = "quote") => {
    if (!billingForm.autoCreateUser && !billingForm.clientUserId) {
      toast.error(
        "Sélectionne un client existant ou active la création automatique du compte.",
      );
      return;
    }
    if (
      !billingForm.clientName ||
      !billingForm.clientEmail ||
      !billingForm.serviceName
    ) {
      toast.error(
        "Renseigne le client, l'email et la prestation avant de generer le document.",
      );
      return;
    }

    try {
      setBillingSaving(true);

      const payload = {
        document_type: type,
        client_name: billingForm.clientName,
        client_email: billingForm.clientEmail,
        service_name: billingForm.serviceName,
        description: billingForm.description,
        amount_ht: Number(amountHt || 0),
        tva_rate: Number(tvaRate || 0),
        billing_mode: billingForm.billingMode,
        installments:
          billingForm.billingMode === "monthly"
            ? Math.max(1, Number(billingForm.installments || 1))
            : null,
        start_date:
          billingForm.billingMode === "monthly" ? billingForm.startDate : null,
        due_days:
          billingForm.billingMode === "invoice"
            ? Number(billingForm.dueDays || 0)
            : null,
      };

      if (billingForm.autoCreateUser) {
        payload.auto_create_user = true;
        if (billingForm.clientFirstname)
          payload.client_firstname = billingForm.clientFirstname;
        if (billingForm.clientLastname)
          payload.client_lastname = billingForm.clientLastname;
      } else {
        payload.id_user_client = Number(billingForm.clientUserId);
      }

      const response = await api.post("/admin/billing-documents", payload);
      const doc = response.data?.data;
      if (!doc) {
        throw new Error("Aucune donnee retournee par l'API");
      }

      setGeneratedDocument(doc);
      toast.success(
        type === "quote" ? "Devis sauvegarde" : "Facture sauvegardee",
      );
    } catch (error) {
      console.error("Erreur generation document:", error);
      const message =
        error?.response?.data?.message ||
        "Impossible de creer le document pour le moment.";
      toast.error(message);
    } finally {
      setBillingSaving(false);
    }
  };

  const downloadGeneratedDocument = async () => {
    if (!generatedDocument?.id_billing_document) return;

    try {
      const response = await api.get(
        `/billing-documents/${generatedDocument.id_billing_document}/download`,
        { responseType: "blob" },
      );

      const contentDisposition =
        response.headers?.["content-disposition"] || "";
      const filenameMatch = contentDisposition.match(
        /filename=\"?([^\";]+)\"?/i,
      );
      const filename =
        filenameMatch?.[1] ||
        `${generatedDocument.document_number || "document"}.txt`;

      const url = URL.createObjectURL(response.data);
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Erreur telechargement document:", error);
      toast.error("Impossible de telecharger ce document.");
    }
  };

  const sendPaymentRequest = async () => {
    if (!generatedDocument?.id_billing_document) return;
    try {
      const res = await api.post(
        `/billing-documents/${generatedDocument.id_billing_document}/send-payment-request`,
      );
      if (res.data?.success) {
        toast.success(res.data.message || "Email de paiement envoyé !");
      } else {
        toast.error(res.data?.message || "Erreur lors de l'envoi.");
      }
    } catch (err) {
      console.error("Erreur envoi demande paiement:", err);
      toast.error("Impossible d'envoyer l'email de paiement.");
    }
  };

  const fetchUsers = async () => {
    try {
      const response = await api.get("/admin/users");
      const raw =
        response.data?.data || response.data?.users || response.data || [];
      const mapped = Array.isArray(raw)
        ? raw.map((u) => ({
            ...u,
            id: u.id_user ?? u.id,
            id_user: u.id_user ?? u.id,
            name:
              u.name ||
              `${u.firstname ?? ""} ${u.lastname ?? ""}`.trim() ||
              u.nickname ||
              u.email,
          }))
        : [];
      setUsers(mapped);
      setFilteredUsers(mapped);
      setTotalPagesUsers(Math.max(1, Math.ceil(mapped.length / itemsPerPage)));
    } catch (error) {
      console.error("Erreur chargement utilisateurs:", error);
      setUsers([]);
      setFilteredUsers([]);
    }
  };

  const fetchCategories = async () => {
    try {
      const response = await api.get("/categories");
      const raw = response.data?.data || response.data || [];
      const mapped = Array.isArray(raw) ? raw : Object.values(raw || {});
      setCategories(mapped);
    } catch (error) {
      console.error("Erreur chargement catégories:", error);
      setCategories([]);
    }
  };

  const handleSaveCategory = async (categoryData) => {
    try {
      if (categoryFormMode === "create") {
        await api.post("/categories", categoryData);
        toast.success("Catégorie créée avec succès");
      } else if (
        selectedCategoryData?.id_category ||
        selectedCategoryData?.id
      ) {
        await api.put(
          `/categories/${selectedCategoryData.id_category || selectedCategoryData.id}`,
          categoryData,
        );
        toast.success("Catégorie modifiée avec succès");
      }

      setCategoryModalOpen(false);
      setSelectedCategoryData(null);
      fetchCategories();
    } catch (error) {
      console.error("Erreur sauvegarde catégorie:", error);
      toast.error(
        error.response?.data?.message ||
          "Erreur lors de la sauvegarde de la catégorie",
      );
    }
  };

  const handleDeleteCategory = async (categoryId) => {
    if (!window.confirm("Supprimer cette catégorie ?")) return;
    try {
      await api.delete(`/categories/${categoryId}`);
      toast.success("Catégorie supprimée");
      fetchCategories();
    } catch (error) {
      console.error("Erreur suppression catégorie:", error);
      toast.error(
        error.response?.data?.message ||
          "Impossible de supprimer cette catégorie",
      );
    }
  };

  const fetchEarnings = async (showSuccessToast = false) => {
    try {
      const response = await api.get("/admin/earnings");
      const earnings = response.data?.earnings || response.data?.data || [];
      setEarningsData(earnings);
      setFilteredEarnings(earnings);
      setTotalPagesEarnings(
        Math.max(1, Math.ceil(earnings.length / itemsPerPage)),
      );
      if (showSuccessToast) {
        toast.success("Données rafraîchies");
      }
    } catch (error) {
      console.error("Erreur chargement gains:", error);
      setEarningsData([]);
      setFilteredEarnings([]);
      if (showSuccessToast) {
        toast.error("Impossible de charger les gains");
      }
    }
  };

  const fetchPromoCodes = async () => {
    try {
      const response = await api.get("/promo-codes");
      const codes = response.data?.data || response.data || [];
      setPromoCodes(Array.isArray(codes) ? codes : []);
    } catch (error) {
      console.error("Erreur chargement codes promo:", error);
      setPromoCodes([]);
    }
  };

  const fetchNewsletter = async () => {
    try {
      const response = await api.get("/admin/newsletter");
      const subscribers = response.data?.data || response.data || [];
      setNewsletterSubscribers(Array.isArray(subscribers) ? subscribers : []);
    } catch (error) {
      console.error("Erreur newsletter:", error);
      setNewsletterSubscribers([]);
    }
  };

  const fetchPricing = async () => {
    try {
      const res = await api.get("/site-settings");
      const plans = res.data?.data?.pricing_plans;
      const noCommitAmount = Number(
        res.data?.data?.no_commitment_amount ?? 3000,
      );

      if (Number.isFinite(noCommitAmount) && noCommitAmount >= 0) {
        setNoCommitmentAmount(noCommitAmount);
      }

      const priceLow = Number(res.data?.data?.hosting_price_low ?? 12);
      const priceHigh = Number(res.data?.data?.hosting_price_high ?? 15);
      if (Number.isFinite(priceLow)) setHostingPriceLow(priceLow);
      if (Number.isFinite(priceHigh)) setHostingPriceHigh(priceHigh);

      if (Array.isArray(plans) && plans.length > 0) {
        setPricingPlans(plans);
      }
    } catch (e) {
      /* fallback */
    }
  };

  const handleSavePricing = async () => {
    try {
      setPricingSaving(true);
      const settingsRes = await api.get("/admin/site-settings");
      const current = settingsRes.data?.data || {};
      await api.put("/admin/site-settings", {
        maintenance_mode: Boolean(current.maintenance_mode),
        blocked_roles: current.blocked_roles || [],
        no_commitment_amount: Number(noCommitmentAmount || 0),
        hosting_price_low: Number(hostingPriceLow || 0),
        hosting_price_high: Number(hostingPriceHigh || 0),
        pricing_plans: pricingPlans.map((p) => ({
          name: p.name,
          price: Number(p.price),
          unit: p.unit,
          installments: Number(p.installments),
        })),
      });
      toast.success("Tarifs enregistres");
      window.dispatchEvent(new Event("siteSettingsUpdated"));
    } catch (e) {
      toast.error("Erreur lors de la sauvegarde des tarifs");
    } finally {
      setPricingSaving(false);
    }
  };

  const fetchSiteSettings = async () => {
    try {
      setSiteSettingsLoading(true);
      const response = await api.get("/admin/site-settings");
      setSiteSettings(
        response.data?.data || { maintenance_mode: false, blocked_roles: [] },
      );
    } catch (error) {
      console.error("Erreur paramètres site:", error);
      toast.error("Impossible de charger les paramètres du site");
      setSiteSettings({ maintenance_mode: false, blocked_roles: [] });
    } finally {
      setSiteSettingsLoading(false);
    }
  };

  const handleToggleBlockedRole = (roleId) => {
    setSiteSettings((prev) => {
      const blockedRoles = Array.isArray(prev.blocked_roles)
        ? prev.blocked_roles.map((role) => Number(role))
        : [];
      const exists = blockedRoles.includes(roleId);

      return {
        ...prev,
        blocked_roles: exists
          ? blockedRoles.filter((role) => role !== roleId)
          : [...blockedRoles, roleId].sort((a, b) => a - b),
      };
    });
  };

  const handleSaveSiteSettings = async () => {
    try {
      setSiteSettingsSaving(true);
      const payload = {
        maintenance_mode: Boolean(siteSettings.maintenance_mode),
        blocked_roles: Array.isArray(siteSettings.blocked_roles)
          ? siteSettings.blocked_roles
              .map((role) => Number(role))
              .filter((role) => [1, 2].includes(role))
          : [],
      };

      const response = await api.put("/admin/site-settings", payload);
      const nextSettings = response.data?.data || payload;
      setSiteSettings(nextSettings);
      toast.success("Paramètres du site enregistrés");
      window.dispatchEvent(new Event("siteSettingsUpdated"));
    } catch (error) {
      console.error("Erreur sauvegarde paramètres site:", error);
      toast.error(
        error.response?.data?.message ||
          "Impossible d'enregistrer les paramètres",
      );
    } finally {
      setSiteSettingsSaving(false);
    }
  };

  const handleTogglePromo = async (promo) => {
    try {
      await api.post(
        `/promo-codes/${promo.id_promo_code || promo.id}/activate`,
        {
          is_active: !promo.is_active,
        },
      );
      setPromoFlashId(promo.id_promo_code || promo.id);
      setTimeout(() => setPromoFlashId(null), 2000);
      toast.success(promo.is_active ? "Code désactivé" : "Code activé");
      fetchPromoCodes();
    } catch (error) {
      console.error("Erreur promo:", error);
      toast.error("Impossible de mettre à jour le code promo");
    }
  };

  const handleCreatePromo = async () => {
    try {
      const payload = {
        code: String(promoForm.code || "")
          .trim()
          .toUpperCase(),
        discount: Number(promoForm.discount || 0),
        start_date: promoForm.start_date || null,
        end_date: promoForm.end_date || null,
        id_product: promoForm.id_product || null,
      };

      await api.post("/promo-codes", payload);
      toast.success("Code promo créé");
      setPromoForm({
        code: "",
        discount: "",
        start_date: "",
        end_date: "",
        id_product: "",
      });
      fetchPromoCodes();
    } catch (error) {
      console.error("Erreur création promo:", error);
      toast.error(
        error.response?.data?.message || "Erreur création code promo",
      );
    }
  };

  const handleDeletePromo = async (promo) => {
    if (!window.confirm(`Supprimer ${promo?.code || "ce code"} ?`)) return;
    try {
      await api.delete(`/promo-codes/${promo.id_promo_code || promo.id}`);
      setPromoCodes((prev) =>
        prev.filter(
          (item) =>
            (item.id_promo_code || item.id) !==
            (promo.id_promo_code || promo.id),
        ),
      );
      toast.success("Code promo supprimé");
    } catch (error) {
      console.error("Erreur suppression promo:", error);
      toast.error("Impossible de supprimer le code promo");
    }
  };

  const handleToggleNewsletter = async (subscriber) => {
    try {
      await api.patch(`/admin/newsletter/${subscriber.id}/toggle`);
      fetchNewsletter();
    } catch (error) {
      console.error("Erreur newsletter toggle:", error);
      toast.error("Impossible de mettre à jour cet abonnement");
    }
  };

  const handleDeleteNewsletter = async (subscriber) => {
    try {
      await api.delete(`/admin/newsletter/${subscriber.id}`);
      fetchNewsletter();
    } catch (error) {
      console.error("Erreur suppression newsletter:", error);
      toast.error("Suppression impossible");
    }
  };

  useEffect(() => {
    fetchUsers();
    fetchCategories();
  }, []);

  useEffect(() => {
    if (activeTab === "promos") {
      fetchPromoCodes();
    }

    if (activeTab === "settings") {
      fetchSiteSettings();
    }
    if (activeTab === "gains") {
      fetchEarnings();
    }
    if (activeTab === "tarifs") {
      fetchPricing();
    }
  }, [activeTab]);

  useEffect(() => {
    if (!productModalOpen || !selectedProduct || categories.length === 0) {
      return;
    }

    const resolvedCategory = resolveSelectedCategoryValue(selectedProduct);
    if (resolvedCategory && resolvedCategory !== selectedCategory) {
      setSelectedCategory(resolvedCategory);
    }
  }, [categories, productModalOpen, selectedProduct]);

  useEffect(() => {
    setSelectedAdminGalleryImage(0);
  }, [selectedProduct, productFormMode, productModalOpen]);

  // ...existing code...
  // Filtrer les utilisateurs selon le sub-tab actif
  useEffect(() => {
    // Filtrer par rôle selon le sub-tab
    const usersByRole =
      userSubTab === "users"
        ? users.filter((u) => u.id_role === 1) // Seulement les utilisateurs (role 1)
        : users; // Tous les users pour le sub-tab créateurs (filtrage fait ailleurs)

    const query = searchUser.toLowerCase();
    const filtered = query
      ? usersByRole.filter(
          (u) =>
            (u.name || "").toLowerCase().includes(query) ||
            (u.email || "").toLowerCase().includes(query) ||
            (u.nickname || "").toLowerCase().includes(query),
        )
      : usersByRole;
    setFilteredUsers(filtered);
    setCurrentPageUsers(1);
    setTotalPagesUsers(Math.max(1, Math.ceil(filtered.length / itemsPerPage)));
  }, [searchUser, users, userSubTab, itemsPerPage]);

  // Filtrer les gains
  useEffect(() => {
    const query = searchEarnings.toLowerCase();
    const filtered = query
      ? earningsData.filter(
          (e) =>
            (e.creator_name || "").toLowerCase().includes(query) ||
            (e.creator_email || "").toLowerCase().includes(query),
        )
      : earningsData;
    setFilteredEarnings(filtered);
    setCurrentPageEarnings(1);
    setTotalPagesEarnings(
      Math.max(1, Math.ceil(filtered.length / itemsPerPage)),
    );
  }, [searchEarnings, earningsData]);

  useEffect(() => {
    const query = searchMessage.toLowerCase();
    const filtered = query
      ? messages.filter(
          (m) =>
            (m.name || "").toLowerCase().includes(query) ||
            (m.email || "").toLowerCase().includes(query) ||
            (m.subject || "").toLowerCase().includes(query) ||
            (m.message || "").toLowerCase().includes(query),
        )
      : messages;

    setFilteredMessages(filtered);
    setTotalPagesMessages(
      Math.max(1, Math.ceil(filtered.length / itemsPerPage)),
    );
    setCurrentPageMessages(1);
  }, [searchMessage, messages]);

  useEffect(() => {
    const query = searchProject.toLowerCase();
    const filtered = query
      ? projects.filter(
          (p) =>
            (p.name || "").toLowerCase().includes(query) ||
            (p.user_name || "").toLowerCase().includes(query) ||
            (p.status || "").toLowerCase().includes(query),
        )
      : projects;

    setFilteredProjects(filtered);
    setTotalPagesProjects(
      Math.max(1, Math.ceil(filtered.length / itemsPerPage)),
    );
    setCurrentPageProjects(1);
  }, [searchProject, projects]);

  // Charger les commandes
  useEffect(() => {
    if (activeTab === "orders") {
      fetchOrders();
    }
  }, [activeTab]);

  const [cashOrders, setCashOrders] = useState([]);
  const [monthlyOrders, setMonthlyOrders] = useState([]);
  const [ordersSubTab, setOrdersSubTab] = useState("cash");

  const fetchOrders = async () => {
    try {
      const response = await api.get("/admin/orders");
      const raw = response.data?.data || [];

      // Commandes site web avec fallback payment_method pour robustesse
      const websiteOrders = raw.filter(
        (o) =>
          o.order_type === "custom_website_order" ||
          o.payment_method === "custom-website-order",
      );

      // cash = paiement unique (+ sans engagement), mensuel = installments
      const cash = websiteOrders.filter(
        (o) =>
          !o.billing_mode ||
          o.billing_mode === "once" ||
          o.billing_mode === "no-commitment",
      );
      const monthly = websiteOrders.filter(
        (o) => o.billing_mode === "installments",
      );

      setCashOrders(cash);
      setMonthlyOrders(monthly);
      setFilteredOrders([]);
      setTotalPagesOrders(1);
    } catch (error) {
      console.error("Erreur lors du chargement des commandes:", error);
      setFilteredOrders([]);
      setCashOrders([]);
      setMonthlyOrders([]);
      setTotalPagesOrders(1);
    }
  };

  const handleUpdateSiteOrderStatus = async (orderId, newStatus) => {
    try {
      await api.put(`/orders/${orderId}`, { status: newStatus });
      toast.success("Statut mis à jour");
      fetchOrders();
    } catch (error) {
      console.error("Erreur mise à jour statut:", error);
      toast.error("Impossible de mettre à jour le statut");
    }
  };

  // Charger les messages de contact
  useEffect(() => {
    if (activeTab === "messages") {
      fetchMessages();
    }
  }, [activeTab, messageTypeFilter]);

  // Charger les devis & factures admin
  useEffect(() => {
    if (activeTab !== "billing") return;
    const fetchAdminBillingDocs = async () => {
      try {
        setAdminBillingLoading(true);
        const res = await api.get("/admin/billing-documents");
        setAdminBillingDocs(res.data?.documents || []);
      } catch (err) {
        console.error("Erreur chargement billing docs:", err);
      } finally {
        setAdminBillingLoading(false);
      }
    };
    fetchAdminBillingDocs();
  }, [activeTab]);

  // Charger les fichiers livrés (livraisons)
  useEffect(() => {
    if (activeTab !== "deliveries") return;
    const fetchDeliveryFiles = async () => {
      try {
        setDeliveryFilesLoading(true);
        const res = await api.get("/admin/delivery-files");
        setDeliveryFiles(res.data?.files || []);
      } catch (err) {
        console.error("Erreur chargement livraisons:", err);
      } finally {
        setDeliveryFilesLoading(false);
      }
    };
    fetchDeliveryFiles();
  }, [activeTab]);

  const fetchMessages = async () => {
    try {
      // Utiliser le nouveau endpoint qui ne retourne que contact_messages
      const endpoint = `/contact/all-messages`;
      const response = await api.get(endpoint);
      const data = response.data?.data || {};
      // Mapper uniquement les messages de contact
      const mapped = (data.contact_messages || []).map((m) => ({
        id: m.id,
        type: "contact",
        name: m.name,
        email: m.email,
        subject: m.service || "Message de contact",
        message:
          m.replies && m.replies.length > 0
            ? (m.replies[m.replies.length - 1]?.message ?? m.message)
            : m.message,
        root_message: m.message,
        status: m.status || "nouveau",
        response: m.response || null,
        response_date: m.response_date || null,
        created_at: m.created_at,
        updated_at: m.updated_at || m.created_at,
        request_type: m.request_type || "support",
        replies: m.replies || [],
      }));
      // Trier par date décroissante
      mapped.sort(
        (a, b) =>
          new Date(b.updated_at || b.created_at) -
          new Date(a.updated_at || a.created_at),
      );
      setMessages(mapped);
      setFilteredMessages(mapped);
      setTotalPagesMessages(
        Math.max(1, Math.ceil(mapped.length / itemsPerPage)),
      );
      // Compter les messages non lus
      const unreadCount = mapped.filter((m) => m.status === "nouveau").length;
      setUnreadMessagesCount(unreadCount);
    } catch (error) {
      console.error("Erreur lors du chargement des messages:", error);
    }
  };

  // Charger les projets
  useEffect(() => {
    if (activeTab === "projects") {
      fetchProjects();
    }
  }, [activeTab]);

  const fetchProjects = async () => {
    try {
      const response = await api.get("/admin/projects");
      const raw = response.data?.projects || [];
      const mapped = raw.map((p) => ({
        id_project: p.id_project ?? p.id,
        name: p.name,
        type: p.type,
        status: p.status,
        progress: p.progress ?? 0,
        description: p.description,
        start_date: p.start_date,
        end_date: p.end_date,
        updated_at: p.updated_at,
        id_user: p.id_user,
        user_name: p.user
          ? p.user.nickname ||
            `${p.user.firstname ?? ""} ${p.user.lastname ?? ""}`.trim() ||
            p.user.email
          : p.user_name,
      }));
      setProjects(mapped);
      setFilteredProjects(mapped);
      setTotalPagesProjects(
        Math.max(1, Math.ceil(mapped.length / itemsPerPage)),
      );
    } catch (error) {
      console.error("Erreur lors du chargement des projets:", error);
      setProjects([]);
      setFilteredProjects([]);
    }
  };

  // Charger les produits et créateurs
  useEffect(() => {
    if (activeTab === "products") {
      fetchProducts();
    }
  }, [activeTab]);

  // Charger la liste des créateurs pour le dropdown
  useEffect(() => {
    fetchCreatorsList();
  }, []);

  const fetchCreatorsList = async () => {
    try {
      const response = await api.get("/admin/creators/list");
      const raw = response.data?.data || response.data || [];
      const mapped = raw.map((c) => ({
        id: c.id_user ?? c.id,
        id_user: c.id_user ?? c.id,
        nickname: c.nickname ?? "",
        fullname:
          `${c.firstname ?? ""} ${c.lastname ?? ""}`.trim() ||
          c.nickname ||
          c.email,
        email: c.email ?? "",
      }));
      setCreatorsList(mapped);
    } catch (error) {
      console.error("Erreur lors du chargement des créateurs:", error);
      setCreatorsList([]);
    }
  };

  const resolveProductImageUrl = (productOrImage) => {
    if (!productOrImage) return null;

    const firstImage =
      Array.isArray(productOrImage.images) && productOrImage.images.length > 0
        ? productOrImage.images[0]
        : null;

    const rawPath =
      productOrImage.path_watermarked ||
      productOrImage.path_image ||
      productOrImage.image ||
      productOrImage.image_url ||
      productOrImage.picture_product ||
      (typeof firstImage === "string"
        ? firstImage
        : firstImage?.path_watermarked || firstImage?.path_image || null);

    if (!rawPath) return null;

    const apiBaseUrl =
      api?.defaults?.baseURL || "https://api.krayneagency.fr/api";
    const apiOrigin = apiBaseUrl.replace(/\/api\/?$/, "");

    if (String(rawPath).startsWith("http")) {
      if (String(rawPath).includes("/api/images/")) {
        try {
          const parsedUrl = new URL(String(rawPath));
          return `${apiOrigin}${parsedUrl.pathname}`;
        } catch {
          return String(rawPath);
        }
      }

      return String(rawPath);
    }

    let cleanPath = String(rawPath).replace(/^\/+/, "");
    if (cleanPath.startsWith("storage/")) cleanPath = cleanPath.substring(8);

    return `${apiOrigin}/api/images/${cleanPath}`;
  };

  const fetchProducts = async () => {
    try {
      // Admin voit tous les produits
      const response = await api.get(`/admin/realisations`);
      const raw = response.data?.data || response.data || [];
      const mapped = raw.map((p) => {
        // Construire la liste d'images depuis main_image + gallery
        const allImagePaths = Array.isArray(p.images)
          ? p.images
          : [p.main_image, ...(p.gallery || [])].filter(Boolean);
        const normalizedImages = allImagePaths.map((img) => {
          if (typeof img === "string") {
            const imageUrl = resolveProductImageUrl({ image: img });
            return { path_image: imageUrl, path_watermarked: imageUrl };
          }
          return {
            ...img,
            path_image: resolveProductImageUrl({ path_image: img?.path_image }),
            path_watermarked: resolveProductImageUrl({
              path_watermarked: img?.path_watermarked || img?.path_image,
            }),
          };
        });

        return {
          id: p.id_realisation ?? p.id,
          id_product: p.id_realisation ?? p.id,
          name: p.title ?? p.name ?? "",
          category: p.category ?? "",
          price: 0,
          price_ht: 0,
          stock: 0,
          sale_type: "libre",
          status: p.status ?? "active",
          creator_type: "krayne",
          creator_name: p.client_name ?? "Krayne Agency",
          id_user_creator: null,
          description: p.description ?? "",
          link: p.project_url ?? p.project_link ?? "",
          images: normalizedImages,
          image: resolveProductImageUrl({ image: p.main_image ?? null }),
          available_stock: 0,
          price_ttc: 0,
          allowed_users: [],
          created_at: p.created_at ?? "",
        };
      });
      setProducts(mapped);
      setFilteredProducts(mapped);
      setTotalPagesProducts(
        Math.max(1, Math.ceil(mapped.length / itemsPerPage)),
      );
      setProductsError(null);
    } catch (error) {
      console.error("Erreur lors du chargement des produits:", error);
      setProducts([]);
      setFilteredProducts([]);
      const serverMessage =
        error.response?.data?.message || error.message || "Erreur inconnue";
      setProductsError(serverMessage);
    }
  };

  // Filtrer les produits (recherche, filtres avancés, visibilité unique)
  useEffect(() => {
    const query = searchProduct.trim().toLowerCase();

    const nextFiltered = products.filter((p) => {
      const matchesQuery = query
        ? (p.name || "").toLowerCase().includes(query) ||
          (p.category || "").toLowerCase().includes(query) ||
          (p.creator_name || "").toLowerCase().includes(query)
        : true;

      const matchesSaleType = productFilters.saleType
        ? (p.sale_type || "").toLowerCase() === productFilters.saleType
        : true;

      // Filtrage par onglet de statut (prioritaire sur le filtre dropdown)
      const matchesStatusTab =
        productStatusTab === "all"
          ? true
          : (p.status || "").toLowerCase() === productStatusTab;

      const matchesStatus = productFilters.status
        ? (p.status || "").toLowerCase() === productFilters.status
        : true;

      const matchesCreatorType = productFilters.creatorType
        ? (p.creator_type || "").toLowerCase() === productFilters.creatorType
        : true;

      const matchesCreatorId = productFilters.creatorId
        ? String(p.id_user_creator ?? "") === String(productFilters.creatorId)
        : true;

      // Si produit unique et restreint : indiquer via badge, mais filtrer seulement si créateur sélectionné
      return (
        matchesQuery &&
        matchesSaleType &&
        matchesStatusTab &&
        matchesStatus &&
        matchesCreatorType &&
        matchesCreatorId
      );
    });

    setFilteredProducts(nextFiltered);
    setTotalPagesProducts(
      Math.max(1, Math.ceil(nextFiltered.length / itemsPerPage)),
    );
    setCurrentPageProducts(1);
  }, [searchProduct, products, itemsPerPage, productFilters, productStatusTab]);

  // Filtrer les créateurs depuis users (role 2)
  useEffect(() => {
    const creatorsFromUsers = users.filter((u) => u.id_role === 2);

    if (searchCreator.trim() === "") {
      setFilteredCreators(creatorsFromUsers);
    } else {
      const filtered = creatorsFromUsers.filter(
        (c) =>
          c.nickname?.toLowerCase().includes(searchCreator.toLowerCase()) ||
          c.firstname?.toLowerCase().includes(searchCreator.toLowerCase()) ||
          c.lastname?.toLowerCase().includes(searchCreator.toLowerCase()) ||
          c.email?.toLowerCase().includes(searchCreator.toLowerCase()),
      );
      setFilteredCreators(filtered);
    }
    setTotalPagesCreators(
      Math.max(1, Math.ceil(filteredCreators.length / itemsPerPage)),
    );
    setCurrentPageCreators(1);
  }, [searchCreator, users, itemsPerPage]);

  // Gestionnaires d'événements
  const handleCreateUser = () => {
    setUserFormMode("create");
    setSelectedUser(null);
    setUserModalOpen(true);
  };

  const handleEditUser = (user) => {
    setUserFormMode("edit");
    setSelectedUser(user);
    setUserModalOpen(true);
  };

  const handleViewUser = (user) => {
    setUserFormMode("view");
    setSelectedUser(user);
    setUserModalOpen(true);
  };

  const handleDeleteUser = async (user) => {
    if (
      window.confirm(
        `Voulez-vous vraiment supprimer l'utilisateur ${user.nickname} ?`,
      )
    ) {
      try {
        await api.delete(`/admin/users/${user.id_user || user.id}`);
        toast.success("Utilisateur supprimé avec succès");
        fetchUsers();
      } catch (error) {
        console.error("Erreur lors de la suppression:", error);
        toast.error(
          error.response?.data?.message || "Erreur lors de la suppression",
        );
      }
    }
  };

  const handleSaveUser = async (userData) => {
    try {
      if (userFormMode === "create") {
        await api.post("/admin/users", userData);
        toast.success("Utilisateur créé avec succès");
      } else {
        const response = await api.put(
          `/admin/users/${selectedUser.id_user || selectedUser.id}`,
          userData,
        );
        toast.success("Utilisateur modifié avec succès");

        // Si l'email a changé, afficher un message de notification
        if (response.data?.emailChanged) {
          toast.info(
            "L'utilisateur devra vérifier son nouvel email pour réactiver son compte",
            { duration: 5000 },
          );
        }

        // Si le statut a changé, afficher un message spécifique
        if (response.data?.statusChanged) {
          if (userData.status === "inactive") {
            toast.error(
              "Compte utilisateur désactivé - il ne pourra plus se connecter",
            );
          } else {
            toast.success("Compte utilisateur réactivé");
          }
        }
      }
      setUserModalOpen(false);
      fetchUsers();
    } catch (error) {
      console.error("Erreur lors de la sauvegarde:", error);
      toast.error(
        error.response?.data?.message || "Erreur lors de la sauvegarde",
      );
    }
  };

  const handleViewOrder = (order) => {
    setSelectedOrder(order);
    setOrderModalOpen(true);
  };

  const handleViewMessage = async (message) => {
    setSelectedMessage(message);
    setReplyText("");
    setMessageModalOpen(true);

    // Recharger le message depuis l'API pour avoir les derniers replies
    try {
      const refreshed = await api.get(`/contact/messages/${message.id}`);
      if (refreshed.data?.message) {
        setSelectedMessage((prev) => ({
          ...prev,
          replies: refreshed.data.message.replies || [],
        }));
      }
    } catch (_) {}

    // Marquer comme lu si c'est un nouveau message
    if (message.status === "nouveau") {
      try {
        await api.put(`/contact/messages/${message.id}/mark-read`);
        // Mettre à jour le message localement
        const updatedMessages = messages.map((m) =>
          m.id === message.id ? { ...m, status: "lu" } : m,
        );
        setMessages(updatedMessages);
        setFilteredMessages(
          updatedMessages.filter((m) => {
            const query = searchMessage.toLowerCase();
            if (!query) return true;
            return (
              (m.name || "").toLowerCase().includes(query) ||
              (m.email || "").toLowerCase().includes(query) ||
              (m.subject || "").toLowerCase().includes(query) ||
              (m.message || "").toLowerCase().includes(query)
            );
          }),
        );
        // Décrémenter le compteur de non lus
        setUnreadMessagesCount((prev) => Math.max(0, prev - 1));
      } catch (error) {
        console.error("Erreur marquage message lu:", error);
      }
    }
  };

  const handleReplyMessage = async () => {
    if (!selectedMessage?.id || !replyText.trim()) return;
    try {
      await api.post(`/contact/messages/${selectedMessage.id}/reply`, {
        response: replyText.trim(),
      });
      toast.success("Réponse envoyée");
      setReplyText("");
      // Recharger le message pour afficher le nouveau reply dans le fil
      try {
        const refreshed = await api.get(
          `/contact/messages/${selectedMessage.id}`,
        );
        if (refreshed.data?.message) {
          setSelectedMessage((prev) => ({
            ...prev,
            replies: refreshed.data.message.replies || [],
            status: refreshed.data.message.status || prev.status,
          }));
        }
      } catch (_) {}
      fetchMessages();
    } catch (error) {
      console.error("Erreur réponse message:", error);
      toast.error(error.response?.data?.message || "Erreur lors de la réponse");
    }
  };

  const handleDeleteMessage = async (message) => {
    if (window.confirm("Voulez-vous vraiment supprimer ce message ?")) {
      try {
        // await api.delete(`/admin/messages/${message.id}`);
        setMessages(messages.filter((m) => m.id !== message.id));
        toast.success("Message supprimé");
      } catch (error) {
        console.error("Erreur:", error);
      }
    }
  };

  // Gestionnaires projets
  const handleCreateProject = () => {
    setProjectFormMode("create");
    setSelectedProject({
      id_user: "",
      name: "",
      type: "",
      status: "En cours",
      progress: 0,
      description: "",
      start_date: "",
      end_date: "",
    });
    setProjectModalOpen(true);
  };

  const handleEditProject = (project) => {
    setProjectFormMode("edit");
    setSelectedProject(project);
    setProjectModalOpen(true);
  };

  const handleViewProject = (project) => {
    setProjectFormMode("view");
    setSelectedProject(project);
    setProjectModalOpen(true);
  };

  const handleDeleteProject = async (project) => {
    if (
      window.confirm(
        `Voulez-vous vraiment supprimer le projet "${project.name}" ?`,
      )
    ) {
      try {
        await api.delete(`/admin/projects/${project.id_project || project.id}`);
        toast.success("Projet supprimé");
        fetchProjects();
      } catch (error) {
        console.error("Erreur suppression projet:", error);
        toast.error(
          error.response?.data?.message || "Erreur lors de la suppression",
        );
      }
    }
  };

  const handleSaveProject = async (projectData) => {
    try {
      if (projectFormMode === "create") {
        await api.post("/admin/projects", projectData);
        toast.success("Projet créé");
      } else {
        await api.put(
          `/admin/projects/${selectedProject.id_project || selectedProject.id}`,
          projectData,
        );
        toast.success("Projet modifié");
      }
      setProjectModalOpen(false);
      fetchProjects();
    } catch (error) {
      console.error("Erreur sauvegarde projet:", error);
      toast.error(
        error.response?.data?.message || "Erreur lors de la sauvegarde",
      );
    }
  };

  // Gestionnaires produits
  const handleCreateProduct = () => {
    setProductFormMode("create");
    setSelectedProduct(
      normalizeProductForForm({
        name: "",
        category: "",
        price: "",
        stock: 1,
        sale_type: "libre",
        status: "active",
        creator_type: defaultCreatorType,
        id_user_creator: defaultCreatorId,
        creator_name: defaultCreatorName,
        description: "",
      }),
    );
    setProductSaleType("libre");
    setSelectedCategory("");
    setAllowedUsers([]);
    setUploadedImages([]);
    setImagePreviews([]);
    setProductFiles([]);
    setProductModalOpen(true);
  };

  const handleEditProduct = async (product) => {
    setProductFormMode("edit");
    setUploadedImages([]);
    setImagePreviews([]);
    setProductFiles([]);

    // Charger le produit complet (avec images) pour l'aperçu fiable
    let full = product;
    try {
      const id = product.id_product || product.id;
      const { data } = await api.get(`/admin/realisations/${id}`);
      full = data?.data || data || product;
    } catch (e) {
      console.warn(
        "Impossible de charger le détail du produit, utilisation des données de la ligne:",
        e?.message,
      );
    }

    const normalizedProduct = normalizeProductForForm(full);

    setSelectedProduct(normalizedProduct);
    setProductSaleType(normalizedProduct?.sale_type || "libre");
    const catName = resolveSelectedCategoryValue(normalizedProduct);
    setSelectedCategory(catName);
    // Extraire les IDs des utilisateurs autorisés (peut être array d'objets ou array de strings)
    const userIds = (normalizedProduct?.allowed_users || []).map((u) =>
      typeof u === "object" ? String(u.id_user || u.id) : String(u),
    );
    setAllowedUsers(userIds);
    setProductModalOpen(true);

    // Initialiser le calcul TVA après ouverture du modal
    setTimeout(() => {
      const priceInput = document.querySelector('input[name="price"]');
      const priceHT = (() => {
        if (!priceInput)
          return (
            parseFloat(normalizedProduct?.price_ht) ||
            parseFloat(normalizedProduct?.price) ||
            0
          );
        return (
          parseFloat(priceInput.value) ||
          parseFloat(normalizedProduct?.price_ht) ||
          parseFloat(normalizedProduct?.price) ||
          0
        );
      })();
      const tva = priceHT * 0.2;
      const priceTTC = priceHT + tva;

      const priceDiv = document.querySelector(".price-calc-display-admin");
      if (priceDiv && priceHT > 0) {
        priceDiv.innerHTML = `
            <div class="text-xs space-y-1.5">
              <div class="flex justify-between"><span>Prix HT:</span><span class="font-semibold">${priceHT.toFixed(2)}€</span></div>
              <div class="flex justify-between"><span>TVA (20%):</span><span class="text-orange-500">${tva.toFixed(2)}€</span></div>
              <div class="border-t border-gray-300 dark:border-white/10 pt-1.5 flex justify-between"><span class="font-semibold">Prix TTC:</span><span class="font-bold text-rose-500">${priceTTC.toFixed(2)}€</span></div>
            </div>
          `;
      }
    }, 200);
  };

  const handleViewProduct = (product) => {
    // Éviter un fetch qui peut renvoyer 500; utiliser les données présentes
    setProductFormMode("view");
    const normalizedProduct = normalizeProductForForm(product);
    setSelectedProduct(normalizedProduct);
    setProductSaleType(normalizedProduct?.sale_type || "libre");
    const catName = resolveSelectedCategoryValue(normalizedProduct);
    setSelectedCategory(catName);
    // Extraire les IDs des utilisateurs autorisés
    const userIds = (normalizedProduct?.allowed_users || []).map((u) =>
      typeof u === "object" ? String(u.id_user || u.id) : String(u),
    );
    setAllowedUsers(userIds);
    setUploadedImages([]);
    setImagePreviews([]);
    setProductFiles([]);
    setProductModalOpen(true);
  };

  const handleDeleteProduct = async (product) => {
    if (
      window.confirm(
        `Voulez-vous vraiment supprimer le produit ${product.name} ?`,
      )
    ) {
      try {
        await api.delete(
          `/admin/realisations/${product.id_product || product.id}`,
        );
        setProducts(
          products.filter(
            (p) =>
              (p.id_product || p.id) !== (product.id_product || product.id),
          ),
        );
        toast.success("Réalisation supprimée avec succès");
        fetchProducts();
      } catch (error) {
        console.error("Erreur lors de la suppression:", error);
        toast.error("Erreur lors de la suppression du produit");
      }
    }
  };

  const handleActivateProduct = async (product) => {
    const id = product?.id_product || product?.id;
    if (!id) {
      toast.error("ID du produit manquant pour activer");
      console.error("Activation produit: ID manquant", product);
      return;
    }

    try {
      // Les réalisations n'ont pas de statut séparé
      toast.success("Réalisation activée");
      fetchProducts();
      toast.success("Produit activé");
      fetchProducts();
    } catch (error) {
      console.error("Erreur lors de l'activation:", error);
      toast.error("Impossible d'activer le produit");
    }
  };

  const handleToggleProductStatus = async (product) => {
    const newStatus = product.status === "active" ? "inactive" : "active";
    try {
      const id = product.id_product || product.id;
      // Les réalisations n'ont pas de champ statut - pas d'action
      toast.success(
        `Réalisation ${newStatus === "active" ? "activée" : "désactivée"}`,
      );
      toast.success(
        `Produit ${newStatus === "active" ? "activé" : "désactivé"} avec succès`,
      );
      fetchProducts();
    } catch (error) {
      console.error("Erreur lors du basculement du statut:", error);
      toast.error("Erreur lors du basculement du statut");
    }
  };

  const MAX_IMAGE_COUNT = 8;
  const MAX_TOTAL_IMAGE_BYTES = 2.5 * 1024 * 1024;
  const MAX_PRODUCT_FILE_COUNT = 8;
  const MAX_SINGLE_PRODUCT_FILE_BYTES = 5 * 1024 * 1024;
  const MAX_TOTAL_PRODUCT_FILE_BYTES = 8 * 1024 * 1024;

  const handleImageUpload = async (e) => {
    e.stopPropagation();
    const existingImages = [...uploadedImages];
    const incomingFiles = Array.from(e.target.files || []);
    const remainingSlots = Math.max(0, MAX_IMAGE_COUNT - existingImages.length);
    const files = incomingFiles.slice(0, remainingSlots);
    if (files.length === 0) {
      if (
        incomingFiles.length > 0 &&
        uploadedImages.length >= MAX_IMAGE_COUNT
      ) {
        toast("Limite de 8 images atteinte.", { icon: "📸" });
      }
      e.target.value = "";
      return;
    }

    try {
      const options = {
        maxSizeMB: 0.35,
        maxWidthOrHeight: 1600,
        useWebWorker: true,
      };

      const compressedFiles = await Promise.all(
        files.map((file) => imageCompression(file, options)),
      );

      const previews = await Promise.all(
        compressedFiles.map(
          (file) =>
            new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.onloadend = () => resolve(reader.result);
              reader.onerror = () =>
                reject(new Error("Erreur lors de la lecture du fichier"));
              reader.readAsDataURL(file);
            }),
        ),
      );

      const totalCompressedBytes = [
        ...existingImages,
        ...compressedFiles,
      ].reduce((sum, file) => sum + file.size, 0);

      if (totalCompressedBytes > MAX_TOTAL_IMAGE_BYTES) {
        toast.error(
          "Les images restent trop lourdes apres compression. Reduis le nombre d'images ou leur resolution.",
        );
        e.target.value = "";
        return;
      }

      setUploadedImages((prev) => [...prev, ...compressedFiles]);
      setImagePreviews((prev) => [...prev, ...previews]);

      if (incomingFiles.length > remainingSlots) {
        toast("Seulement les emplacements restants ont été conservés.", {
          icon: "📸",
        });
      }

      if (totalCompressedBytes > 1024 * 1024) {
        toast(
          "Les images ont ete compressees pour rester compatibles avec la limite serveur.",
          { icon: "🗜️" },
        );
      }
      e.target.value = "";
    } catch (error) {
      console.error("Erreur handleImageUpload:", error);
      toast.error("Erreur lors du traitement des images");
      e.target.value = "";
    }
  };

  const handleRemoveUploadedImg = (indexToRemove) => {
    setUploadedImages((prev) =>
      prev.filter((_, index) => index !== indexToRemove),
    );
    setImagePreviews((prev) =>
      prev.filter((_, index) => index !== indexToRemove),
    );
  };

  const handleProductFilesChange = (e) => {
    const files = Array.from(e.target.files || []).slice(
      0,
      MAX_PRODUCT_FILE_COUNT,
    );
    const tooLargeFile = files.find(
      (file) => file.size > MAX_SINGLE_PRODUCT_FILE_BYTES,
    );
    const totalBytes = files.reduce((sum, file) => sum + file.size, 0);

    if (tooLargeFile) {
      toast.error(`Le fichier ${tooLargeFile.name} depasse la limite de 5 Mo.`);
      setProductFiles([]);
      return;
    }

    if (totalBytes > MAX_TOTAL_PRODUCT_FILE_BYTES) {
      toast.error("Les fichiers telechargeables depassent 8 Mo au total.");
      setProductFiles([]);
      return;
    }

    setProductFiles(files);

    if ((e.target.files || []).length > MAX_PRODUCT_FILE_COUNT) {
      toast("Seulement les 8 premiers fichiers ont été conservés.", {
        icon: "📎",
      });
    }
  };

  // Handlers Créateurs
  const fetchCreators = async () => {
    try {
      const response = await api.get("/admin/creators");
      const raw =
        response.data?.creators || response.data?.data || response.data || [];
      const mapped = raw.map((c) => ({
        id_user: c.id_user ?? c.id,
        id: c.id_user ?? c.id,
        nickname: c.nickname ?? "",
        firstname: c.firstname ?? "",
        lastname: c.lastname ?? "",
        email: c.email ?? "",
        id_role: c.id_role ?? 2,
        role: c.role ?? c.role_name ?? "Créateur",
        status: c.status ?? "active",
        email_verified_at: c.email_verified_at,
        created_at: c.created_at,
      }));
      setCreators(mapped);
    } catch (error) {
      console.error("Erreur lors du chargement des créateurs:", error);
    }
  };

  const handleEditCreator = (creator) => {
    setCreatorFormMode("edit");
    setSelectedCreator(creator);
    setUploadedCreatorImage(null);
    setCreatorModalOpen(true);
  };

  const handleViewCreator = (creator) => {
    setCreatorFormMode("view");
    setSelectedCreator(creator);
    setCreatorModalOpen(true);
  };

  const handleDeleteCreator = async (creator) => {
    if (
      window.confirm(
        `Voulez-vous vraiment supprimer le créateur ${creator.nickname} ?`,
      )
    ) {
      try {
        await api.delete(`/admin/creators/${creator.id_user}`);
        toast.success("Créateur supprimé avec succès");
        fetchCreators();
        fetchCreatorsList();
      } catch (error) {
        console.error("Erreur lors de la suppression:", error);
        if (error.response?.status === 409) {
          toast.error(
            "Impossible de supprimer ce créateur car il a des produits associés.",
          );
        } else {
          toast.error("Erreur lors de la suppression du créateur");
        }
      }
    }
  };

  const handleSaveCreator = async (creatorData) => {
    try {
      const formData = new FormData();
      formData.append("nickname", creatorData.nickname);
      formData.append("firstname", creatorData.firstname);
      formData.append("lastname", creatorData.lastname);
      formData.append("email", creatorData.email);

      if (creatorData.password) {
        formData.append("password", creatorData.password);
      }

      if (uploadedCreatorImage) {
        formData.append("picture_user", uploadedCreatorImage);
      }

      if (creatorFormMode === "create") {
        await api.post("/admin/creators", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        toast.success("Créateur créé avec succès!");
      } else {
        await api.put(`/admin/creators/${selectedCreator.id_user}`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        toast.success("Créateur modifié avec succès");
      }

      setCreatorModalOpen(false);
      setUploadedCreatorImage(null);
      fetchCreators();
      fetchCreatorsList();
    } catch (error) {
      console.error("Erreur lors de la sauvegarde:", error);
      toast.error(
        "Erreur lors de la sauvegarde: " +
          (error.response?.data?.message || error.message),
      );
    }
  };

  const handleCreatorImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setUploadedCreatorImage(file);
    }
  };

  const handleSaveProduct = async (productData) => {
    try {
      // Vérifier l'authentification avant toute chose
      if (!isAuthenticated) {
        toast.error("Vous devez être connecté pour ajouter un produit", {
          duration: 4000,
          icon: "🔒",
          style: {
            background: isDark ? "#1f2937" : "#ffffff",
            color: isDark ? "#ffffff" : "#1f2937",
            border: "2px solid #ef4444",
          },
        });
        return;
      }

      // Validation côté client pour éviter un aller-retour inutile si l'image manque
      if (productFormMode === "create" && uploadedImages.length === 0) {
        toast.error(
          "Veuillez sélectionner entre 1 et 8 images avant de créer le produit",
        );
        return;
      }

      // Validation catégorie
      if (!productData.category || productData.category.trim() === "") {
        toast.error("Veuillez saisir ou sélectionner une catégorie");
        return;
      }

      const formData = new FormData();
      formData.append("name", productData.name);
      formData.append("category", productData.category);
      formData.append("description", productData.description || "");
      formData.append(
        "client_name",
        productData.creator_name || "Krayne Agency",
      );
      // Toujours envoyer la clé pour permettre de retirer un lien existant.
      formData.append("project_url", (productData.link || "").trim());
      if (productData.id_user_client != null) {
        formData.append("id_user_client", productData.id_user_client);
      }
      // Visibilité publique
      const isFeaturedEl = document.getElementById("is_featured");
      formData.append("is_featured", isFeaturedEl?.checked ? "1" : "0");

      if (uploadedImages.length > 0) {
        formData.append("image", uploadedImages[0]);
        uploadedImages.forEach((image) => {
          formData.append("images[]", image);
        });
      }

      if (productFormMode === "create") {
        await api.post("/admin/realisations", formData);
        toast.success("Réalisation créée avec succès !");
      } else {
        // Laravel ne supporte pas PUT avec multipart/form-data
        // On utilise POST avec _method=PUT
        formData.append("_method", "PUT");
        await api.post(
          `/admin/realisations/${selectedProduct.id_product || selectedProduct.id}`,
          formData,
        );
        toast.success("Réalisation modifiée avec succès");
      }

      setProductModalOpen(false);
      setUploadedImages([]);
      setImagePreviews([]);
      setProductFiles([]);
      fetchProducts();
    } catch (error) {
      console.error(
        "Erreur lors de la sauvegarde:",
        error.response?.data || error,
      );
      if (error?.response?.status === 413) {
        toast.error(
          "Le formulaire est trop lourd pour le serveur. Reduis le nombre ou la taille des images et fichiers.",
        );
        return;
      }
      const serverMessage = error.response?.data?.message || error.message;
      // Si le backend retourne des erreurs de validation, afficher la première
      const validationErrors = error.response?.data?.errors;
      const firstValidationError = validationErrors
        ? Object.values(validationErrors)[0]?.[0]
        : null;
      toast.error(
        "Erreur lors de la sauvegarde: " +
          (firstValidationError || serverMessage),
      );
    }
  };

  const tabs = [
    { id: "products", label: "Réalisations", icon: Package },
    { id: "users", label: "Utilisateurs", icon: Users },
    { id: "categories", label: "Catégories", icon: FolderKanban },
    { id: "projects", label: "Projets", icon: FolderKanban },
    { id: "messages", label: "Messages", icon: MessageSquare },
    { id: "orders", label: "Commandes", icon: ShoppingBag },
    { id: "gains", label: "Gains", icon: TrendingUp },
    { id: "tarifs", label: "Tarifs", icon: DollarSign },
    { id: "billing", label: "Devis & Facturation", icon: Receipt },
    { id: "deliveries", label: "Livraisons", icon: Package },
    { id: "settings", label: "Réglages", icon: Settings },
  ];

  const StatCard = ({ icon: Icon, title, value, trend, color }) => (
    <div
      className={`p-6 rounded-xl border ${isDark ? "bg-[#0b0b0c] border-white/10" : "bg-white border-gray-200"}`}
    >
      <div className="flex items-center justify-between mb-4">
        <div className={`p-3 rounded-lg ${color}`}>
          <Icon className="w-6 h-6" />
        </div>
        {trend && (
          <div className="flex items-center gap-1 text-sm text-rose-500">
            <TrendingUp className="w-4 h-4" />
            <span>{trend}</span>
          </div>
        )}
      </div>
      <h3
        className={`text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
      >
        {title}
      </h3>
      <p className="text-2xl font-bold">{value}</p>
    </div>
  );

  const productFormValues =
    normalizeProductForForm(selectedProduct) ||
    normalizeProductForForm({
      creator_type: defaultCreatorType,
      id_user_creator: defaultCreatorId,
      creator_name: defaultCreatorName,
      stock: 1,
      status: "active",
      sale_type: "libre",
    });

  const resolvedCreatorType =
    productFormValues?.creator_type || defaultCreatorType;
  const resolvedCreatorId =
    productFormValues?.id_user_creator ?? defaultCreatorId;
  const resolvedCreatorName =
    productFormValues?.creator_name ?? defaultCreatorName;

  return (
    <div
      className={`flex-1 flex flex-col ${isDark ? "bg-[#0f1114] text-white" : "bg-slate-50 text-gray-800"}`}
    >
      <div className="container mx-auto px-4 py-8 max-w-7xl">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold mb-2">Administration</h1>
          <p
            className={`text-sm ${isDark ? "text-gray-400" : "text-gray-600"}`}
          >
            Bienvenue, {user?.name || "Admin"} • Dernière connexion :
            Aujourd'hui à 14:32
          </p>
        </div>

        {/* Tabs Navigation */}
        <div
          className={`mb-6 rounded-3xl border p-3 ${isDark ? "bg-[linear-gradient(180deg,rgba(255,255,255,0.03),rgba(255,255,255,0.01))] border-white/10 shadow-[0_10px_35px_rgba(0,0,0,0.18)]" : "bg-[linear-gradient(180deg,#ffffff,#fbfbfd)] border-gray-200 shadow-[0_10px_30px_rgba(15,23,42,0.06)]"}`}
        >
          <div className="flex flex-wrap items-center justify-center gap-2">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`relative flex min-h-[48px] items-center justify-center gap-2 rounded-full px-4 py-2.5 text-sm font-medium leading-tight transition-all select-none ${
                    activeTab === tab.id
                      ? "bg-rose-500 text-white shadow-[0_10px_30px_rgba(244,63,94,0.28)] ring-2 ring-rose-500/20"
                      : isDark
                        ? "bg-white/[0.03] text-gray-300 hover:bg-white/[0.06] hover:text-white border border-white/5"
                        : "bg-gray-50 text-gray-700 hover:bg-gray-100 hover:text-gray-900 border border-gray-200"
                  }`}
                  title={tab.label}
                >
                  <Icon className="w-4 h-4" />
                  <span className="whitespace-nowrap">{tab.label}</span>
                  {tab.id === "messages" && unreadMessagesCount > 0 && (
                    <span className="absolute -top-1 -right-1 bg-rose-500 text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
                      {unreadMessagesCount}
                    </span>
                  )}
                </button>
              );
            })}
          </div>
        </div>

        {/* Content */}

        {activeTab === "products" && (
          <div className="space-y-4">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-xl font-semibold">
                Gestion des réalisations
              </h2>
              <button
                onClick={handleCreateProduct}
                className="flex items-center gap-2 px-4 py-2 bg-rose-500 text-white rounded-lg hover:bg-rose-600 transition-colors text-sm font-medium"
              >
                <Plus className="w-4 h-4" />
                Nouvelle réalisation
              </button>
            </div>

            {/* Filtres rapides statut */}
            <div className="flex flex-wrap gap-2 mb-4">
              {[
                { key: "all", label: "Tous" },
                { key: "active", label: "Actifs" },
                { key: "inactive", label: "Inactifs" },
              ].map((tab) => (
                <button
                  key={tab.key}
                  onClick={() => setProductStatusTab(tab.key)}
                  className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-all ${
                    productStatusTab === tab.key
                      ? "bg-gradient-to-r from-rose-500 to-indigo-500 text-white"
                      : isDark
                        ? "bg-white/5 text-gray-400 hover:bg-white/10"
                        : "bg-gray-100 text-gray-600 hover:bg-gray-200"
                  }`}
                >
                  {tab.label}
                </button>
              ))}
            </div>

            <div className="mb-4">
              <SearchBar
                value={searchProduct}
                onChange={setSearchProduct}
                placeholder="Rechercher une réalisation..."
              />
            </div>

            {productsError ? (
              <div className="p-4 rounded-xl bg-red-500/10 border border-red-500/20 text-red-400 text-sm">
                Erreur : {productsError}
              </div>
            ) : (
              <>
                <TableAdmin
                  columns={[
                    {
                      key: "image",
                      label: "",
                      render: (img) =>
                        img ? (
                          <img
                            src={img}
                            alt=""
                            className="w-10 h-10 rounded-lg object-cover"
                            onError={(e) => {
                              e.target.style.display = "none";
                            }}
                          />
                        ) : (
                          <div className="w-10 h-10 rounded-lg bg-white/5 flex items-center justify-center text-gray-500 text-xs">
                            <Package className="w-4 h-4" />
                          </div>
                        ),
                    },
                    { key: "name", label: "Nom" },
                    { key: "category", label: "Catégorie" },
                    {
                      key: "link",
                      label: "Lien",
                      render: (link) =>
                        link ? (
                          <a
                            href={link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-violet-400 hover:underline text-xs truncate max-w-[160px] block"
                            onClick={(e) => e.stopPropagation()}
                          >
                            {link}
                          </a>
                        ) : (
                          <span className="text-gray-500 text-xs">—</span>
                        ),
                    },
                    {
                      key: "status",
                      label: "Statut",
                      render: (status) => (
                        <span
                          className={`px-2 py-0.5 rounded text-xs font-medium ${
                            status === "active"
                              ? "bg-green-500/20 text-green-500"
                              : "bg-red-500/20 text-red-400"
                          }`}
                        >
                          {status === "active" ? "Actif" : "Inactif"}
                        </span>
                      ),
                    },
                  ]}
                  data={filteredProducts.slice(
                    (currentPageProducts - 1) * itemsPerPage,
                    currentPageProducts * itemsPerPage,
                  )}
                  onView={handleViewProduct}
                  onEdit={handleEditProduct}
                  onDelete={handleDeleteProduct}
                />

                <Pagination
                  currentPage={currentPageProducts}
                  totalPages={totalPagesProducts}
                  onPageChange={setCurrentPageProducts}
                />
              </>
            )}
          </div>
        )}

        {activeTab === "users" && (
          <div className="space-y-4">
            {/* Contenu Utilisateurs */}
            {userSubTab === "users" && (
              <>
                <div className="flex items-center justify-between mb-6">
                  <h2 className="text-xl font-semibold">
                    Gestion des utilisateurs
                  </h2>
                  <button
                    onClick={handleCreateUser}
                    className="flex items-center gap-2 px-4 py-2 bg-rose-500 text-white rounded-lg hover:bg-rose-600 transition-colors text-sm font-medium"
                  >
                    <Plus className="w-4 h-4" />
                    Nouvel utilisateur
                  </button>
                </div>

                <div className="mb-4">
                  <SearchBar
                    value={searchUser}
                    onChange={setSearchUser}
                    placeholder="Rechercher un utilisateur..."
                  />
                </div>

                <TableAdmin
                  columns={[
                    { key: "id_user", label: "ID" },
                    { key: "nickname", label: "Pseudo" },
                    { key: "email", label: "Email" },
                    {
                      key: "id_role",
                      label: "Rôle",
                      render: (role) => (
                        <span
                          className={`px-2 py-1 rounded text-xs font-medium ${
                            role === 3
                              ? "bg-purple-500/20 text-purple-500"
                              : "bg-rose-500/20 text-rose-400"
                          }`}
                        >
                          {role === 3 ? "Admin" : "Client"}
                        </span>
                      ),
                    },
                    {
                      key: "email_verified_at",
                      label: "Vérification Email",
                      render: (verified) => (
                        <span
                          className={`px-2 py-1 rounded text-xs font-medium ${
                            verified
                              ? "bg-green-500/20 text-green-500"
                              : "bg-orange-500/20 text-orange-500"
                          }`}
                        >
                          {verified ? "✓ Vérifié" : "⏳ En attente"}
                        </span>
                      ),
                    },
                    {
                      key: "status",
                      label: "Statut",
                      render: (status) => (
                        <span
                          className={`px-2 py-1 rounded text-xs ${
                            status === "active"
                              ? "bg-green-500/20 text-green-500"
                              : "bg-red-500/20 text-red-500"
                          }`}
                        >
                          {status === "active" ? "Actif" : "Inactif"}
                        </span>
                      ),
                    },
                    { key: "created_at", label: "Date inscription" },
                  ]}
                  data={filteredUsers.slice(
                    (currentPageUsers - 1) * itemsPerPage,
                    currentPageUsers * itemsPerPage,
                  )}
                  onView={handleViewUser}
                  onEdit={handleEditUser}
                  onDelete={handleDeleteUser}
                />

                <Pagination
                  currentPage={currentPageUsers}
                  totalPages={totalPagesUsers}
                  onPageChange={setCurrentPageUsers}
                />
              </>
            )}
          </div>
        )}

        {activeTab === "messages" && <MessagingAdmin isDark={isDark} />}

        {activeTab === "orders" && (
          <div className="space-y-4">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-xl font-semibold">Gestion des commandes</h2>
            </div>

            {/* Sous-onglets commandes */}
            <div
              className={`flex gap-1 p-1 rounded-xl mb-6 ${isDark ? "bg-white/5" : "bg-gray-100"}`}
            >
              {[
                {
                  id: "cash",
                  label: `Paiement cash (${cashOrders.length})`,
                },
                {
                  id: "monthly",
                  label: `Paiement mensuel (${monthlyOrders.length})`,
                },
              ].map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => setOrdersSubTab(tab.id)}
                  className={`flex-1 px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                    ordersSubTab === tab.id
                      ? "bg-gradient-to-r from-rose-500 via-purple-500 to-indigo-500 text-white shadow"
                      : isDark
                        ? "text-gray-400 hover:text-white"
                        : "text-gray-600 hover:text-gray-900"
                  }`}
                >
                  {tab.label}
                </button>
              ))}
            </div>

            {/* --- Vue: Commandes site web (cash / mensuel) --- */}
            {(ordersSubTab === "cash" || ordersSubTab === "monthly") && (
              <div className="space-y-4">
                {(ordersSubTab === "cash" ? cashOrders : monthlyOrders)
                  .length === 0 ? (
                  <div
                    className={`text-center py-12 rounded-xl border ${isDark ? "border-white/10 text-gray-500" : "border-gray-200 text-gray-400"}`}
                  >
                    {ordersSubTab === "cash"
                      ? "Aucune commande cash pour le moment."
                      : "Aucune commande mensuelle pour le moment."}
                  </div>
                ) : (
                  (ordersSubTab === "cash" ? cashOrders : monthlyOrders).map(
                    (order) => {
                      const SITE_STEPS = [
                        { key: "pending", label: "Demande reçue" },
                        { key: "en-cours", label: "Validation" },
                        { key: "production", label: "Production" },
                        { key: "livré", label: "Livraison" },
                      ];
                      const stepIndex = SITE_STEPS.findIndex(
                        (s) => s.key === order.status,
                      );
                      const activeStep = stepIndex === -1 ? 0 : stepIndex;

                      const billingLabel =
                        {
                          once: "Paiement unique",
                          installments: "Mensuel (36 mois)",
                          "no-commitment": "Sans engagement",
                        }[order.billing_mode] ||
                        order.billing_mode ||
                        "—";

                      const isCancelled = order.status === "cancelled";

                      return (
                        <div
                          key={order.id}
                          className={`rounded-xl border p-5 space-y-4 ${isDark ? "bg-[#0b0b0c] border-white/10" : "bg-white border-gray-200"}`}
                        >
                          {/* Header */}
                          <div className="flex flex-wrap items-start justify-between gap-3">
                            <div>
                              <div className="flex items-center gap-2 flex-wrap">
                                <span className="text-sm font-mono font-bold">
                                  {order.reference || `#${order.id}`}
                                </span>
                                <span className="px-2 py-0.5 rounded-full text-xs font-semibold bg-indigo-500/20 text-indigo-400">
                                  Site web
                                </span>
                                {order.plan_name && (
                                  <span className="px-2 py-0.5 rounded-full text-xs font-semibold bg-purple-500/20 text-purple-400">
                                    {order.plan_name}
                                  </span>
                                )}
                                {order.billing_mode && (
                                  <span className="px-2 py-0.5 rounded-full text-xs font-semibold bg-rose-500/20 text-rose-400">
                                    {billingLabel}
                                  </span>
                                )}
                                {isCancelled && (
                                  <span className="px-2 py-0.5 rounded-full text-xs font-semibold bg-red-500/20 text-red-400">
                                    Annulée
                                  </span>
                                )}
                              </div>
                              <p
                                className={`text-sm mt-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
                              >
                                Client :{" "}
                                <span className="font-medium text-white">
                                  {order.user_name || "—"}
                                </span>
                                {order.user_email && (
                                  <span className="ml-2 text-xs opacity-60">
                                    {order.user_email}
                                  </span>
                                )}
                              </p>
                            </div>
                            <div className="text-right">
                              <div className="text-lg font-bold">
                                {(order.total ?? 0).toLocaleString("fr-FR")}€
                              </div>
                              <div
                                className={`text-xs mt-0.5 ${isDark ? "text-gray-500" : "text-gray-400"}`}
                              >
                                {order.created_at
                                  ? new Date(
                                      order.created_at,
                                    ).toLocaleDateString("fr-FR")
                                  : "—"}
                              </div>
                            </div>
                          </div>

                          {/* Message client */}
                          {order.customer_message && (
                            <div
                              className={`p-3 rounded-lg text-sm italic ${isDark ? "bg-white/5 text-gray-300" : "bg-gray-50 text-gray-700"}`}
                            >
                              "{order.customer_message}"
                            </div>
                          )}

                          {/* Timeline */}
                          {!isCancelled && (
                            <div className="relative flex items-center justify-between mt-2">
                              <div
                                className={`absolute left-0 right-0 h-0.5 top-4 ${isDark ? "bg-white/10" : "bg-gray-200"}`}
                              />
                              <div
                                className="absolute left-0 h-0.5 top-4 bg-gradient-to-r from-rose-500 via-purple-500 to-indigo-500 transition-all duration-500"
                                style={{
                                  width: `${(activeStep / (SITE_STEPS.length - 1)) * 100}%`,
                                }}
                              />
                              {SITE_STEPS.map((step, i) => (
                                <div
                                  key={step.key}
                                  className="relative flex flex-col items-center z-10"
                                  style={{
                                    width: `${100 / SITE_STEPS.length}%`,
                                  }}
                                >
                                  <div
                                    className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold border-2 transition-all ${
                                      i < activeStep
                                        ? "bg-gradient-to-br from-rose-500 to-indigo-500 border-transparent text-white"
                                        : i === activeStep
                                          ? "bg-gradient-to-br from-rose-500 to-indigo-500 border-white text-white shadow-lg scale-110"
                                          : isDark
                                            ? "bg-[#0b0b0c] border-white/20 text-gray-500"
                                            : "bg-white border-gray-300 text-gray-400"
                                    }`}
                                  >
                                    {i < activeStep ? "✓" : i + 1}
                                  </div>
                                  <span
                                    className={`text-xs mt-1.5 text-center leading-tight ${
                                      i === activeStep
                                        ? "font-semibold text-white"
                                        : isDark
                                          ? "text-gray-500"
                                          : "text-gray-400"
                                    }`}
                                  >
                                    {step.label}
                                  </span>
                                </div>
                              ))}
                            </div>
                          )}

                          {/* Actions statut */}
                          <div className="flex flex-wrap gap-2 pt-2 border-t border-white/10">
                            <span
                              className={`text-xs font-medium self-center ${isDark ? "text-gray-400" : "text-gray-500"}`}
                            >
                              Changer le statut :
                            </span>
                            {SITE_STEPS.map((step) => (
                              <button
                                key={step.key}
                                onClick={() =>
                                  handleUpdateSiteOrderStatus(
                                    order.id,
                                    step.key,
                                  )
                                }
                                disabled={order.status === step.key}
                                className={`px-3 py-1 rounded-lg text-xs font-medium transition-all ${
                                  order.status === step.key
                                    ? "bg-gradient-to-r from-rose-500 to-indigo-500 text-white cursor-default"
                                    : isDark
                                      ? "bg-white/5 text-gray-300 hover:bg-white/10 border border-white/10"
                                      : "bg-gray-100 text-gray-700 hover:bg-gray-200 border border-gray-200"
                                }`}
                              >
                                {step.label}
                              </button>
                            ))}
                            <button
                              onClick={() =>
                                handleUpdateSiteOrderStatus(
                                  order.id,
                                  "cancelled",
                                )
                              }
                              disabled={order.status === "cancelled"}
                              className={`px-3 py-1 rounded-lg text-xs font-medium transition-all ${
                                order.status === "cancelled"
                                  ? "bg-red-500/20 text-red-400 cursor-default border border-red-500/20"
                                  : "bg-red-500/10 text-red-400 hover:bg-red-500/20 border border-red-500/20"
                              }`}
                            >
                              Annuler
                            </button>
                          </div>
                        </div>
                      );
                    },
                  )
                )}
              </div>
            )}
          </div>
        )}

        {activeTab === "categories" && (
          <div className="space-y-4">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-xl font-semibold">Gestion des catégories</h2>
              <button
                onClick={() => {
                  setSelectedCategoryData(null);
                  setCategoryFormMode("create");
                  setCategoryModalOpen(true);
                }}
                className="flex items-center gap-2 px-4 py-2 bg-rose-500 text-white rounded-lg hover:bg-rose-600 transition-colors text-sm font-medium"
              >
                <Plus className="w-4 h-4" />
                Ajouter une catégorie
              </button>
            </div>

            <TableAdmin
              columns={[
                { key: "name", label: "Nom" },
                { key: "slug", label: "Slug" },
                {
                  key: "product_count",
                  label: "Produits",
                  render: (_, cat) => cat.products?.length || 0,
                },
                {
                  key: "created_at",
                  label: "Créée le",
                  render: (date) =>
                    date ? new Date(date).toLocaleDateString("fr-FR") : "-",
                },
              ]}
              data={categories}
              onEdit={(cat) => {
                setSelectedCategoryData(cat);
                setCategoryFormMode("edit");
                setCategoryModalOpen(true);
              }}
              onDelete={(cat) => handleDeleteCategory(cat.id_category)}
            />
          </div>
        )}

        {activeTab === "projects" && (
          <div className="space-y-4">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-xl font-semibold">Gestion des projets</h2>
              <button
                onClick={handleCreateProject}
                className="flex items-center gap-2 px-4 py-2 bg-rose-500 text-white rounded-lg hover:bg-rose-600 transition-colors text-sm font-medium"
              >
                <Plus className="w-4 h-4" />
                Créer un projet
              </button>
            </div>

            <div className="mb-4">
              <SearchBar
                value={searchProject}
                onChange={setSearchProject}
                placeholder="Rechercher un projet..."
              />
            </div>

            <TableAdmin
              columns={[
                { key: "id_project", label: "ID" },
                { key: "name", label: "Nom" },
                { key: "user_name", label: "Client" },
                { key: "type", label: "Type" },
                {
                  key: "status",
                  label: "Statut",
                  render: (status) => (
                    <span
                      className={`px-2 py-1 rounded text-xs font-medium ${
                        status === "En cours"
                          ? "bg-blue-500/20 text-blue-500"
                          : status === "Terminé"
                            ? "bg-green-500/20 text-green-500"
                            : "bg-yellow-500/20 text-yellow-500"
                      }`}
                    >
                      {status}
                    </span>
                  ),
                },
                {
                  key: "progress",
                  label: "Progression",
                  render: (progress) => `${progress || 0}%`,
                },
              ]}
              data={filteredProjects.slice(
                (currentPageProjects - 1) * itemsPerPage,
                currentPageProjects * itemsPerPage,
              )}
              onView={handleViewProject}
              onEdit={handleEditProject}
              onDelete={handleDeleteProject}
            />

            <Pagination
              currentPage={currentPageProjects}
              totalPages={totalPagesProjects}
              onPageChange={setCurrentPageProjects}
            />
          </div>
        )}

        {/* Gains */}
        {activeTab === "gains" && (
          <div className="space-y-6">
            <div className="flex items-center justify-between">
              <div>
                <h2 className="text-xl font-semibold">Gains & revenus</h2>
                <p
                  className={`text-sm mt-1 ${isDark ? "text-gray-400" : "text-gray-500"}`}
                >
                  Vue d'ensemble des revenus generes par l'agence.
                </p>
              </div>
              <button
                onClick={() => fetchEarnings(true)}
                className={`flex items-center gap-2 px-4 py-2 rounded-xl border text-sm font-medium transition-all ${isDark ? "border-white/10 text-gray-300 hover:bg-white/5" : "border-gray-200 text-gray-700 hover:bg-gray-50"}`}
              >
                <TrendingUp className="w-4 h-4" />
                Rafraichir
              </button>
            </div>

            {/* Stats cards */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {[
                {
                  label: "Chiffre d'affaires",
                  value: earningsData.reduce(
                    (s, e) => s + Number(e.total_revenue || e.amount || 0),
                    0,
                  ),
                  suffix: "€",
                  color: "text-rose-500",
                },
                {
                  label: "Commandes",
                  value: earningsData.length,
                  suffix: "",
                  color: "text-violet-400",
                },
                {
                  label: "Tax (20%)",
                  value: Math.round(
                    earningsData.reduce(
                      (s, e) => s + Number(e.total_revenue || e.amount || 0),
                      0,
                    ) * 0.2,
                  ),
                  suffix: "€",
                  color: "text-orange-400",
                },
                {
                  label: "Net (après tax)",
                  value: Math.round(
                    earningsData.reduce(
                      (s, e) => s + Number(e.total_revenue || e.amount || 0),
                      0,
                    ) * 0.8,
                  ),
                  suffix: "€",
                  color: "text-green-400",
                },
              ].map((card) => (
                <div
                  key={card.label}
                  className={`p-5 rounded-xl border flex flex-col gap-2 ${isDark ? "bg-[#0b0b0c] border-white/10" : "bg-white border-gray-200"}`}
                >
                  <p
                    className={`text-[10px] font-bold uppercase tracking-widest ${isDark ? "text-gray-600" : "text-gray-400"}`}
                  >
                    {card.label}
                  </p>
                  <p className={`text-2xl font-black ${card.color}`}>
                    {Number(card.value).toLocaleString("fr-FR")}
                    {card.suffix}
                  </p>
                </div>
              ))}
            </div>

            {/* Search */}
            <div>
              <SearchBar
                value={searchEarnings}
                onChange={setSearchEarnings}
                placeholder="Rechercher par createur ou email..."
              />
            </div>

            {/* Table */}
            {filteredEarnings.length === 0 ? (
              <div
                className={`p-8 rounded-xl border text-center ${isDark ? "bg-[#0b0b0c] border-white/10" : "bg-white border-gray-200"}`}
              >
                <TrendingUp
                  className={`w-10 h-10 mx-auto mb-3 ${isDark ? "text-gray-700" : "text-gray-300"}`}
                />
                <p
                  className={`text-sm ${isDark ? "text-gray-500" : "text-gray-400"}`}
                >
                  Aucun gain enregistre pour le moment.
                </p>
              </div>
            ) : (
              <>
                <TableAdmin
                  columns={[
                    { key: "creator_name", label: "Createur" },
                    { key: "creator_email", label: "Email" },
                    {
                      key: "total_revenue",
                      label: "Revenus",
                      render: (v) =>
                        `${Number(v || 0).toLocaleString("fr-FR")}€`,
                    },
                    {
                      key: "order_count",
                      label: "Commandes",
                      render: (v) => v ?? "-",
                    },
                    {
                      key: "period",
                      label: "Periode",
                      render: (v) => v || "-",
                    },
                  ]}
                  data={filteredEarnings.slice(
                    (currentPageEarnings - 1) * itemsPerPage,
                    currentPageEarnings * itemsPerPage,
                  )}
                  onView={null}
                  onEdit={null}
                  onDelete={null}
                />
                <Pagination
                  currentPage={currentPageEarnings}
                  totalPages={totalPagesEarnings}
                  onPageChange={setCurrentPageEarnings}
                />
              </>
            )}
          </div>
        )}

        {/* Tarifs */}
        {activeTab === "tarifs" && (
          <div className="space-y-6">
            <div className="flex items-center justify-between">
              <div>
                <h2 className="text-xl font-semibold">Tarifs du site</h2>
                <p
                  className={`text-sm mt-1 ${isDark ? "text-gray-400" : "text-gray-500"}`}
                >
                  Definissez le prix total et le nombre d'echeances. La
                  mensualite se calcule automatiquement.
                </p>
              </div>
              <button
                onClick={handleSavePricing}
                disabled={pricingSaving}
                className="flex items-center gap-2 px-4 py-2 text-white text-sm font-semibold rounded-xl transition-all disabled:opacity-50"
                style={{
                  background:
                    "linear-gradient(135deg, #f43f5e 0%, #a855f7 50%, #6366f1 100%)",
                }}
              >
                {pricingSaving ? "Enregistrement..." : "Sauvegarder les tarifs"}
              </button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {pricingPlans.map((plan, i) => {
                const monthly =
                  plan.installments > 1
                    ? Math.ceil(plan.price / plan.installments)
                    : null;
                return (
                  <div
                    className={`p-5 rounded-xl border flex flex-col gap-4 ${isDark ? "bg-[#0b0b0c] border-white/10" : "bg-white border-gray-200"}`}
                  >
                    {/* En-tete plan */}
                    <div className="flex items-center justify-between">
                      <p
                        className={`text-[10px] font-bold uppercase tracking-widest ${isDark ? "text-gray-500" : "text-gray-400"}`}
                      >
                        {plan.name}
                      </p>
                      <span
                        className={`text-[10px] px-2 py-0.5 rounded-full font-medium ${isDark ? "bg-white/5 text-gray-500" : "bg-gray-100 text-gray-400"}`}
                      >
                        /{plan.unit}
                      </span>
                    </div>

                    {/* Prix total */}
                    <div>
                      <label
                        className={`block text-xs font-semibold mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
                      >
                        Prix total
                      </label>
                      <div className="flex items-center gap-2">
                        <input
                          type="number"
                          min="0"
                          max="99999"
                          value={plan.price}
                          onChange={(e) => {
                            const updated = [...pricingPlans];
                            updated[i] = {
                              ...updated[i],
                              price: Number(e.target.value),
                            };
                            setPricingPlans(updated);
                          }}
                          className={`w-full px-3 py-2.5 rounded-lg border text-2xl font-black focus:outline-none focus:ring-2 focus:ring-rose-500/50 ${isDark ? "bg-white/5 border-white/10 text-white" : "bg-gray-50 border-gray-200 text-gray-900"}`}
                        />
                        <span
                          className={`text-lg font-bold flex-shrink-0 ${isDark ? "text-gray-400" : "text-gray-500"}`}
                        >
                          €
                        </span>
                      </div>
                    </div>

                    {/* Nombre d'echeances */}
                    <div>
                      <label
                        className={`block text-xs font-semibold mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
                      >
                        Nombre d'echeances
                      </label>
                      <input
                        type="number"
                        min="1"
                        max="24"
                        value={plan.installments}
                        onChange={(e) => {
                          const updated = [...pricingPlans];
                          updated[i] = {
                            ...updated[i],
                            installments: Math.max(1, Number(e.target.value)),
                          };
                          setPricingPlans(updated);
                        }}
                        className={`w-full px-3 py-2 rounded-lg border text-base font-semibold focus:outline-none focus:ring-2 focus:ring-violet-500/50 ${isDark ? "bg-white/5 border-white/10 text-white" : "bg-gray-50 border-gray-200 text-gray-900"}`}
                      />
                    </div>

                    {/* Mensualite calculee automatiquement */}
                    <div
                      className={`rounded-lg p-3 border ${isDark ? "bg-white/[0.03] border-white/[0.07]" : "bg-gray-50 border-gray-100"}`}
                    >
                      {monthly ? (
                        <div className="flex items-baseline justify-between">
                          <span
                            className={`text-xs ${isDark ? "text-gray-500" : "text-gray-400"}`}
                          >
                            Mensualite calculee
                          </span>
                          <span>
                            <span
                              className={`text-xl font-black ${isDark ? "text-white" : "text-gray-900"}`}
                            >
                              {monthly.toLocaleString("fr-FR")}€
                            </span>
                            <span
                              className={`text-xs ml-1 ${isDark ? "text-gray-600" : "text-gray-400"}`}
                            >
                              /mois x{plan.installments}
                            </span>
                          </span>
                        </div>
                      ) : (
                        <p
                          className={`text-xs ${isDark ? "text-gray-600" : "text-gray-400"}`}
                        >
                          Paiement en une seule fois
                        </p>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>

            <div
              className={`p-5 rounded-xl border ${isDark ? "bg-[#0b0b0c] border-white/10" : "bg-white border-gray-200"}`}
            >
              <p
                className={`text-[10px] font-bold uppercase tracking-widest mb-3 ${isDark ? "text-gray-500" : "text-gray-400"}`}
              >
                Option sans engagement
              </p>
              <label
                className={`block text-xs font-semibold mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
              >
                Montant fixe sans engagement
              </label>
              <div className="flex items-center gap-2 max-w-xs">
                <input
                  type="number"
                  min="0"
                  max="99999"
                  value={noCommitmentAmount}
                  onChange={(e) =>
                    setNoCommitmentAmount(
                      Math.max(0, Number(e.target.value || 0)),
                    )
                  }
                  className={`w-full px-3 py-2.5 rounded-lg border text-2xl font-black focus:outline-none focus:ring-2 focus:ring-rose-500/50 ${isDark ? "bg-white/5 border-white/10 text-white" : "bg-gray-50 border-gray-200 text-gray-900"}`}
                />
                <span
                  className={`text-lg font-bold flex-shrink-0 ${isDark ? "text-gray-400" : "text-gray-500"}`}
                >
                  €
                </span>
              </div>
              <p
                className={`text-xs mt-2 ${isDark ? "text-gray-500" : "text-gray-500"}`}
              >
                Ce montant est affiche sur la page Tarifs dans le bloc "sans
                engagement".
              </p>
            </div>

            {/* Hébergement */}
            <div
              className={`p-5 rounded-xl border ${isDark ? "bg-[#0b0b0c] border-white/10" : "bg-white border-gray-200"}`}
            >
              <p
                className={`text-[10px] font-bold uppercase tracking-widest mb-4 ${isDark ? "text-sky-500" : "text-sky-500"}`}
              >
                Hébergement mensuel
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label
                    className={`block text-xs font-semibold mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
                  >
                    Prix standard (€/mois)
                  </label>
                  <div className="flex items-center gap-2">
                    <input
                      type="number"
                      min="0"
                      max="9999"
                      step="0.01"
                      value={hostingPriceLow}
                      onChange={(e) =>
                        setHostingPriceLow(
                          Math.max(0, Number(e.target.value || 0)),
                        )
                      }
                      className={`w-full px-3 py-2.5 rounded-lg border text-2xl font-black focus:outline-none focus:ring-2 focus:ring-sky-500/50 ${isDark ? "bg-white/5 border-white/10 text-white" : "bg-gray-50 border-gray-200 text-gray-900"}`}
                    />
                    <span
                      className={`text-lg font-bold flex-shrink-0 ${isDark ? "text-gray-400" : "text-gray-500"}`}
                    >
                      €
                    </span>
                  </div>
                  <p
                    className={`text-xs mt-1 ${isDark ? "text-gray-600" : "text-gray-400"}`}
                  >
                    Sites vitrine &amp; standard
                  </p>
                </div>
                <div>
                  <label
                    className={`block text-xs font-semibold mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
                  >
                    Prix site complexe (€/mois)
                  </label>
                  <div className="flex items-center gap-2">
                    <input
                      type="number"
                      min="0"
                      max="9999"
                      step="0.01"
                      value={hostingPriceHigh}
                      onChange={(e) =>
                        setHostingPriceHigh(
                          Math.max(0, Number(e.target.value || 0)),
                        )
                      }
                      className={`w-full px-3 py-2.5 rounded-lg border text-2xl font-black focus:outline-none focus:ring-2 focus:ring-sky-500/50 ${isDark ? "bg-white/5 border-white/10 text-white" : "bg-gray-50 border-gray-200 text-gray-900"}`}
                    />
                    <span
                      className={`text-lg font-bold flex-shrink-0 ${isDark ? "text-gray-400" : "text-gray-500"}`}
                    >
                      €
                    </span>
                  </div>
                  <p
                    className={`text-xs mt-1 ${isDark ? "text-gray-600" : "text-gray-400"}`}
                  >
                    E-commerce &amp; sites complexes
                  </p>
                </div>
              </div>
              <p
                className={`text-xs mt-3 ${isDark ? "text-gray-600" : "text-gray-400"}`}
              >
                Ces prix s'affichent sur la page Tarifs — section Hébergement et
                bannière add-on.
              </p>
            </div>

            <div
              className={`flex items-start gap-3 p-4 rounded-xl border text-sm ${isDark ? "bg-white/[0.02] border-white/[0.06] text-gray-500" : "bg-gray-50 border-gray-200 text-gray-500"}`}
            >
              <span className="text-base flex-shrink-0">i</span>
              <p>
                Les modifications de prix s'appliquent uniquement aux{" "}
                <strong>nouvelles commandes</strong>. Un client ayant deja un
                paiement echelonne en cours conserve son tarif d'origine.
              </p>
            </div>
          </div>
        )}

        {/* Devis & Facturation */}
        {activeTab === "billing" && (
          <div className="space-y-6">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
              <div>
                <h2 className="text-xl font-semibold">Devis & facturation</h2>
                <p
                  className={`text-sm mt-1 ${isDark ? "text-gray-400" : "text-gray-500"}`}
                >
                  Crée un devis ou une facture en direct, avec paiement unique
                  ou mensualisé.
                </p>
              </div>
              <div className="flex gap-2">
                <button
                  onClick={() => generateBillingDocument("quote")}
                  disabled={billingSaving}
                  className={`px-4 py-2 rounded-xl text-sm font-semibold border flex items-center gap-2 ${
                    isDark
                      ? "border-white/10 bg-white/[0.04] text-gray-200 hover:bg-white/[0.08]"
                      : "border-gray-200 bg-white text-gray-700 hover:bg-gray-50"
                  }`}
                >
                  <FileText className="w-4 h-4" />{" "}
                  {billingSaving ? "Sauvegarde..." : "Generer devis"}
                </button>
                <button
                  onClick={() => generateBillingDocument("invoice")}
                  disabled={billingSaving}
                  className="px-4 py-2 rounded-xl text-sm font-semibold text-white flex items-center gap-2"
                  style={{
                    background:
                      "linear-gradient(135deg, #f43f5e 0%, #a855f7 50%, #6366f1 100%)",
                  }}
                >
                  <Receipt className="w-4 h-4" />{" "}
                  {billingSaving ? "Sauvegarde..." : "Generer facture"}
                </button>
              </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
              <div
                className={`p-5 rounded-xl border space-y-4 ${isDark ? "bg-[#0b0b0c] border-white/10" : "bg-white border-gray-200"}`}
              >
                <h3 className="font-semibold">Paramètres document</h3>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  {/* Toggle création automatique */}
                  <div className="sm:col-span-2">
                    <label className="flex items-center gap-3 cursor-pointer select-none">
                      <div
                        onClick={() =>
                          setBillingForm((p) => ({
                            ...p,
                            autoCreateUser: !p.autoCreateUser,
                            clientUserId: "",
                          }))
                        }
                        className={`relative w-11 h-6 rounded-full transition-colors ${billingForm.autoCreateUser ? "bg-violet-600" : isDark ? "bg-white/20" : "bg-gray-300"}`}
                      >
                        <span
                          className={`absolute top-1 left-1 w-4 h-4 rounded-full bg-white transition-transform ${billingForm.autoCreateUser ? "translate-x-5" : ""}`}
                        />
                      </div>
                      <span
                        className={`text-sm ${isDark ? "text-gray-300" : "text-gray-700"}`}
                      >
                        Créer automatiquement le compte client
                      </span>
                    </label>
                    <p
                      className={`text-xs mt-1 ${isDark ? "text-gray-500" : "text-gray-400"}`}
                    >
                      {billingForm.autoCreateUser
                        ? "Un compte sera créé avec l'email ci-dessous. Le mot de passe temporaire sera affiché après génération."
                        : "Le document sera lié à un compte client existant."}
                    </p>
                  </div>

                  {/* Sélection client existant (si auto-create OFF) */}
                  {!billingForm.autoCreateUser && (
                    <div className="sm:col-span-2">
                      <label
                        className={`block text-xs mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
                      >
                        Client de l'espace client
                      </label>
                      <select
                        value={billingForm.clientUserId}
                        onChange={(e) => {
                          const selectedId = e.target.value;
                          const selectedUser = users.find(
                            (u) =>
                              String(u.id_user ?? u.id) === String(selectedId),
                          );
                          setBillingForm((p) => ({
                            ...p,
                            clientUserId: selectedId,
                            clientName:
                              selectedUser?.name ||
                              `${selectedUser?.firstname ?? ""} ${selectedUser?.lastname ?? ""}`.trim() ||
                              selectedUser?.nickname ||
                              p.clientName,
                            clientEmail: selectedUser?.email || p.clientEmail,
                          }));
                        }}
                        className={`w-full px-3 py-2 rounded-lg border ${isDark ? "bg-white/5 border-white/10 text-white" : "bg-gray-50 border-gray-200 text-gray-900"}`}
                      >
                        <option value="">Selectionner un client</option>
                        {users
                          .filter((u) => Number(u.id_role) === 1)
                          .map((u) => (
                            <option
                              key={u.id_user ?? u.id}
                              value={u.id_user ?? u.id}
                            >
                              {u.name ||
                                `${u.firstname ?? ""} ${u.lastname ?? ""}`.trim() ||
                                u.nickname ||
                                "Client"}
                              {u.email ? ` (${u.email})` : ""}
                            </option>
                          ))}
                      </select>
                    </div>
                  )}

                  <div>
                    <label
                      className={`block text-xs mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
                    >
                      Client
                    </label>
                    <input
                      value={billingForm.clientName}
                      onChange={(e) =>
                        setBillingForm((p) => ({
                          ...p,
                          clientName: e.target.value,
                        }))
                      }
                      className={`w-full px-3 py-2 rounded-lg border ${isDark ? "bg-white/5 border-white/10 text-white" : "bg-gray-50 border-gray-200 text-gray-900"}`}
                      placeholder="Nom complet du client"
                    />
                  </div>
                  <div>
                    <label
                      className={`block text-xs mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
                    >
                      Email client
                    </label>
                    <input
                      value={billingForm.clientEmail}
                      onChange={(e) =>
                        setBillingForm((p) => ({
                          ...p,
                          clientEmail: e.target.value,
                        }))
                      }
                      className={`w-full px-3 py-2 rounded-lg border ${isDark ? "bg-white/5 border-white/10 text-white" : "bg-gray-50 border-gray-200 text-gray-900"}`}
                      placeholder="client@email.com"
                    />
                  </div>
                  <div>
                    <label
                      className={`block text-xs mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
                    >
                      Prestation
                    </label>
                    <input
                      value={billingForm.serviceName}
                      onChange={(e) =>
                        setBillingForm((p) => ({
                          ...p,
                          serviceName: e.target.value,
                        }))
                      }
                      className={`w-full px-3 py-2 rounded-lg border ${isDark ? "bg-white/5 border-white/10 text-white" : "bg-gray-50 border-gray-200 text-gray-900"}`}
                      placeholder="Ex: Site vitrine"
                    />
                  </div>
                  <div>
                    <label
                      className={`block text-xs mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
                    >
                      Montant HT (€)
                    </label>
                    <input
                      type="number"
                      min="0"
                      value={billingForm.amountHt}
                      onChange={(e) =>
                        setBillingForm((p) => ({
                          ...p,
                          amountHt: Number(e.target.value),
                        }))
                      }
                      className={`w-full px-3 py-2 rounded-lg border ${isDark ? "bg-white/5 border-white/10 text-white" : "bg-gray-50 border-gray-200 text-gray-900"}`}
                    />
                  </div>
                  <div>
                    <label
                      className={`block text-xs mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
                    >
                      TVA (%)
                    </label>
                    <input
                      type="number"
                      min="0"
                      max="100"
                      value={billingForm.tvaRate}
                      onChange={(e) =>
                        setBillingForm((p) => ({
                          ...p,
                          tvaRate: Number(e.target.value),
                        }))
                      }
                      className={`w-full px-3 py-2 rounded-lg border ${isDark ? "bg-white/5 border-white/10 text-white" : "bg-gray-50 border-gray-200 text-gray-900"}`}
                    />
                  </div>
                  <div>
                    <label
                      className={`block text-xs mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
                    >
                      Formule
                    </label>
                    <select
                      value={billingForm.formulaKey}
                      onChange={(e) => applyBillingFormula(e.target.value)}
                      className={`w-full px-3 py-2 rounded-lg border ${isDark ? "bg-white/5 border-white/10 text-white" : "bg-gray-50 border-gray-200 text-gray-900"}`}
                    >
                      {billingFormulaOptions.map((option) => (
                        <option key={option.key} value={option.key}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label
                      className={`block text-xs mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
                    >
                      Mode de facturation
                    </label>
                    <select
                      value={billingForm.billingMode}
                      onChange={(e) =>
                        setBillingForm((p) => ({
                          ...p,
                          billingMode: e.target.value,
                        }))
                      }
                      className={`w-full px-3 py-2 rounded-lg border ${isDark ? "bg-white/5 border-white/10 text-white" : "bg-gray-50 border-gray-200 text-gray-900"}`}
                    >
                      <option value="invoice">Cash (paiement unique)</option>
                      <option value="monthly">Mensuel</option>
                    </select>
                  </div>
                </div>

                <div>
                  <label
                    className={`block text-xs mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
                  >
                    Description
                  </label>
                  <textarea
                    rows={3}
                    value={billingForm.description}
                    onChange={(e) =>
                      setBillingForm((p) => ({
                        ...p,
                        description: e.target.value,
                      }))
                    }
                    className={`w-full px-3 py-2 rounded-lg border ${isDark ? "bg-white/5 border-white/10 text-white" : "bg-gray-50 border-gray-200 text-gray-900"}`}
                    placeholder="Détails de la prestation"
                  />
                </div>

                {billingForm.billingMode === "monthly" ? (
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    <div>
                      <label
                        className={`block text-xs mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
                        for="installments"
                      >
                        Nombre d'échéances
                      </label>
                      <input
                        type="number"
                        min="1"
                        max="36"
                        value={billingForm.installments}
                        onChange={(e) =>
                          setBillingForm((p) => ({
                            ...p,
                            installments: Math.max(1, Number(e.target.value)),
                          }))
                        }
                        className={`w-full px-3 py-2 rounded-lg border ${isDark ? "bg-white/5 border-white/10 text-white" : "bg-gray-50 border-gray-200 text-gray-900"}`}
                      />
                    </div>
                    <div>
                      <label
                        className={`block text-xs mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
                        for="startDate"
                      >
                        Date de début
                      </label>
                      <input
                        type="date"
                        value={billingForm.startDate}
                        onChange={(e) =>
                          setBillingForm((p) => ({
                            ...p,
                            startDate: e.target.value,
                          }))
                        }
                        className={`w-full px-3 py-2 rounded-lg border ${isDark ? "bg-white/5 border-white/10 text-white" : "bg-gray-50 border-gray-200 text-gray-900"}`}
                      />
                    </div>
                  </div>
                ) : (
                  <div>
                    <label
                      className={`block text-xs mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
                      for="dueDays"
                    >
                      Délai de paiement (jours)
                    </label>
                    <input
                      type="number"
                      min="0"
                      max="120"
                      value={billingForm.dueDays}
                      onChange={(e) =>
                        setBillingForm((p) => ({
                          ...p,
                          dueDays: Number(e.target.value),
                        }))
                      }
                      className={`w-full px-3 py-2 rounded-lg border ${isDark ? "bg-white/5 border-white/10 text-white" : "bg-gray-50 border-gray-200 text-gray-900"}`}
                    />
                  </div>
                )}
              </div>

              <div
                className={`p-5 rounded-xl border ${isDark ? "bg-[#0b0b0c] border-white/10" : "bg-white border-gray-200"}`}
              >
                <h3 className="font-semibold mb-4 flex items-center gap-2">
                  <Calculator className="w-4 h-4" /> Aperçu & calculs
                </h3>
                <div className="space-y-3 text-sm">
                  <div className="flex justify-between">
                    <span
                      className={isDark ? "text-gray-400" : "text-gray-600"}
                    >
                      Montant HT
                    </span>
                    <strong>{amountHt.toFixed(2)} €</strong>
                  </div>
                  <div className="flex justify-between">
                    <span
                      className={isDark ? "text-gray-400" : "text-gray-600"}
                    >
                      TVA ({tvaRate}%)
                    </span>
                    <strong>{tvaAmount.toFixed(2)} €</strong>
                  </div>
                  <div className="flex justify-between border-t pt-2">
                    <span
                      className={isDark ? "text-gray-300" : "text-gray-700"}
                    >
                      Total TTC
                    </span>
                    <strong>{amountTtc.toFixed(2)} €</strong>
                  </div>
                  {billingForm.billingMode === "monthly" && (
                    <div className="flex justify-between">
                      <span
                        className={isDark ? "text-gray-300" : "text-gray-700"}
                      >
                        Mensualité
                      </span>
                      <strong>
                        {monthlyAmount.toFixed(2)} € x{installmentsCount}
                      </strong>
                    </div>
                  )}
                </div>

                {generatedDocument ? (
                  <div
                    className={`mt-5 p-4 rounded-lg border ${isDark ? "bg-white/[0.03] border-white/[0.07]" : "bg-gray-50 border-gray-200"}`}
                  >
                    <p className="text-xs font-bold uppercase tracking-wider mb-2">
                      {generatedDocument.document_type === "quote"
                        ? "Devis sauvegarde"
                        : "Facture sauvegardee"}
                    </p>
                    <p className="text-sm">
                      N° {generatedDocument.document_number}
                    </p>
                    <p
                      className={`text-xs ${isDark ? "text-gray-400" : "text-gray-600"}`}
                    >
                      {generatedDocument.client_name} •{" "}
                      {generatedDocument.client_email}
                    </p>
                    <p className="text-sm mt-2 font-semibold">
                      {generatedDocument.service_name}
                    </p>
                    <p
                      className={`text-xs mt-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
                    >
                      {generatedDocument.billing_mode === "monthly"
                        ? "Mensuel"
                        : "Cash (paiement unique)"}
                    </p>

                    {/* Identifiants temporaires si compte créé automatiquement */}
                    {generatedDocument.temp_credentials && (
                      <div
                        className={`mt-4 p-3 rounded-lg border ${isDark ? "bg-yellow-500/10 border-yellow-500/30" : "bg-yellow-50 border-yellow-300"}`}
                      >
                        <p className="text-xs font-bold text-yellow-500 uppercase tracking-wider mb-2">
                          Compte client créé automatiquement
                        </p>
                        <p
                          className={`text-xs ${isDark ? "text-gray-300" : "text-gray-700"}`}
                        >
                          <span className="font-semibold">Email :</span>{" "}
                          {generatedDocument.temp_credentials.email}
                        </p>
                        <p
                          className={`text-xs mt-1 ${isDark ? "text-gray-300" : "text-gray-700"}`}
                        >
                          <span className="font-semibold">
                            Mot de passe temporaire :
                          </span>{" "}
                          <code className="font-mono bg-black/20 px-1 rounded">
                            {generatedDocument.temp_credentials.password}
                          </code>
                        </p>
                        <p
                          className={`text-xs mt-2 italic ${isDark ? "text-gray-500" : "text-gray-400"}`}
                        >
                          Transmets ces identifiants au client pour qu'il puisse
                          accéder à son espace et signer le devis.
                        </p>
                        <button
                          onClick={() => {
                            const txt = `Email : ${generatedDocument.temp_credentials.email}\nMot de passe : ${generatedDocument.temp_credentials.password}`;
                            navigator.clipboard.writeText(txt);
                            toast.success("Identifiants copiés !");
                          }}
                          className={`mt-2 px-3 py-1 rounded text-xs font-semibold ${isDark ? "bg-yellow-500/20 text-yellow-400 hover:bg-yellow-500/30" : "bg-yellow-200 text-yellow-800 hover:bg-yellow-300"}`}
                        >
                          Copier les identifiants
                        </button>
                      </div>
                    )}

                    {/* Lien espace client */}
                    <div
                      className={`mt-4 p-3 rounded-lg border ${isDark ? "bg-violet-500/10 border-violet-500/30" : "bg-violet-50 border-violet-200"}`}
                    >
                      <p className="text-xs font-bold text-violet-500 uppercase tracking-wider mb-1">
                        Lien pour le client
                      </p>
                      <p
                        className={`text-xs ${isDark ? "text-gray-400" : "text-gray-600"}`}
                      >
                        Le client retrouve son devis dans son espace client
                        après connexion.
                      </p>
                      <button
                        onClick={() => {
                          navigator.clipboard.writeText(
                            `${window.location.origin}/espace-client`,
                          );
                          toast.success("Lien copié !");
                        }}
                        className={`mt-2 px-3 py-1 rounded text-xs font-semibold ${isDark ? "bg-violet-500/20 text-violet-400 hover:bg-violet-500/30" : "bg-violet-100 text-violet-700 hover:bg-violet-200"}`}
                      >
                        Copier le lien espace client
                      </button>
                    </div>

                    {/* Signature manuscrite si présente */}
                    {generatedDocument.signature_data && (
                      <div className="mt-4">
                        <span className="block text-xs text-gray-400 mb-1">
                          Empreinte de signature :
                        </span>
                        <img
                          src={generatedDocument.signature_data}
                          alt="Signature manuscrite"
                          style={{
                            maxWidth: 240,
                            maxHeight: 90,
                            border: "1px solid #ddd",
                            background: "#fff",
                            borderRadius: 6,
                          }}
                        />
                      </div>
                    )}
                    <button
                      onClick={downloadGeneratedDocument}
                      className="mt-4 w-full px-3 py-2 rounded-lg text-sm font-semibold text-white"
                      style={{
                        background:
                          "linear-gradient(135deg, #f43f5e 0%, #a855f7 50%, #6366f1 100%)",
                      }}
                    >
                      Télécharger le document
                    </button>
                    {generatedDocument.document_type === "quote" && (
                      <button
                        onClick={sendPaymentRequest}
                        className="mt-2 w-full px-3 py-2 rounded-lg text-sm font-semibold text-white"
                        style={{
                          background:
                            "linear-gradient(135deg, #22c55e 0%, #16a34a 100%)",
                        }}
                      >
                        ✉ Envoyer demande de paiement
                      </button>
                    )}
                  </div>
                ) : (
                  <p
                    className={`mt-5 text-sm ${isDark ? "text-gray-500" : "text-gray-500"}`}
                  >
                    Remplis les champs, puis clique sur "Generer devis" ou
                    "Generer facture".
                  </p>
                )}
              </div>
            </div>

            {/* Liste Devis & Factures existants */}
            <div
              className={`p-6 rounded-xl border ${isDark ? "bg-[#0b0b0c] border-white/10" : "bg-white border-gray-200"}`}
            >
              <h3 className="text-base font-semibold mb-4">
                Documents existants
              </h3>

              {/* Sous-onglets */}
              <div className="flex gap-2 mb-5">
                {[
                  { key: "quotes", label: "📄 Devis" },
                  { key: "invoices", label: "🧾 Factures" },
                ].map((tab) => (
                  <button
                    key={tab.key}
                    onClick={() => setAdminBillingSubTab(tab.key)}
                    className={`px-4 py-2 rounded-lg text-sm font-medium transition ${
                      adminBillingSubTab === tab.key
                        ? "bg-indigo-600 text-white"
                        : isDark
                          ? "bg-white/5 text-white/60 hover:bg-white/10"
                          : "bg-gray-100 text-gray-600 hover:bg-gray-200"
                    }`}
                  >
                    {tab.label}
                  </button>
                ))}
              </div>

              {adminBillingLoading ? (
                <p
                  className={`text-sm ${isDark ? "text-gray-400" : "text-gray-500"}`}
                >
                  Chargement...
                </p>
              ) : (
                (() => {
                  const docType =
                    adminBillingSubTab === "quotes" ? "quote" : "invoice";
                  const docs = adminBillingDocs.filter(
                    (d) => d.document_type === docType,
                  );
                  if (docs.length === 0)
                    return (
                      <p
                        className={`text-sm ${isDark ? "text-gray-500" : "text-gray-500"}`}
                      >
                        Aucun{" "}
                        {adminBillingSubTab === "quotes" ? "devis" : "facture"}{" "}
                        pour le moment.
                      </p>
                    );
                  const statusColors = {
                    draft: isDark
                      ? "bg-gray-700 text-gray-300"
                      : "bg-gray-100 text-gray-600",
                    sent: isDark
                      ? "bg-blue-900/40 text-blue-300"
                      : "bg-blue-50 text-blue-700",
                    accepted: isDark
                      ? "bg-green-900/30 text-green-400"
                      : "bg-green-50 text-green-700",
                    paid: isDark
                      ? "bg-green-900/50 text-green-300"
                      : "bg-green-100 text-green-800",
                    rejected: isDark
                      ? "bg-red-900/30 text-red-400"
                      : "bg-red-50 text-red-700",
                    cancelled: isDark
                      ? "bg-red-900/30 text-red-400"
                      : "bg-red-50 text-red-700",
                  };
                  const statusLabels = {
                    draft: "Brouillon",
                    sent: "Envoyé",
                    accepted: "Accepté",
                    paid: "Payé",
                    rejected: "Refusé",
                    cancelled: "Annulé",
                  };
                  return (
                    <div className="space-y-2">
                      {docs.map((doc) => (
                        <div
                          key={doc.id_billing_document}
                          className={`flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 p-3 rounded-lg border ${isDark ? "bg-white/5 border-white/10" : "bg-gray-50 border-gray-200"}`}
                        >
                          <div className="flex-1 min-w-0">
                            <div className="flex items-center gap-2 flex-wrap">
                              <span className="font-semibold text-sm">
                                {doc.document_number}
                              </span>
                              <span
                                className={`px-2 py-0.5 rounded text-xs font-semibold ${statusColors[doc.status] || statusColors.draft}`}
                              >
                                {statusLabels[doc.status] || doc.status}
                              </span>
                              {doc.is_signed && (
                                <span className="px-2 py-0.5 rounded text-xs bg-indigo-500/20 text-indigo-400">
                                  Signé
                                </span>
                              )}
                              {doc.billing_mode === "monthly" && (
                                <span className="px-2 py-0.5 rounded text-xs bg-purple-500/20 text-purple-400">
                                  Mensuel {doc.paid_installments || 0}/
                                  {doc.installments}
                                </span>
                              )}
                            </div>
                            <p
                              className={`text-xs mt-0.5 truncate ${isDark ? "text-white/60" : "text-gray-500"}`}
                            >
                              {doc.client_name || doc.client_email || "—"} ·{" "}
                              {doc.service_name} ·{" "}
                              {Number(doc.amount_ttc || 0).toFixed(2)} €
                            </p>
                            <p
                              className={`text-xs ${isDark ? "text-white/40" : "text-gray-400"}`}
                            >
                              {new Date(doc.created_at).toLocaleDateString(
                                "fr-FR",
                              )}
                            </p>
                          </div>
                          <div className="flex gap-2 shrink-0 items-center">
                            {/* Badge statut (lecture seule) */}
                            <span
                              className={`px-2 py-1.5 rounded text-xs font-semibold ${statusColors[doc.status] || statusColors.draft}`}
                            >
                              {statusLabels[doc.status] || doc.status}
                            </span>
                            <button
                              onClick={async () => {
                                try {
                                  const res = await api.get(
                                    `/billing-documents/${doc.id_billing_document}/download`,
                                    { responseType: "blob" },
                                  );
                                  const url = URL.createObjectURL(
                                    new Blob([res.data], {
                                      type: "application/pdf",
                                    }),
                                  );
                                  const link = document.createElement("a");
                                  link.href = url;
                                  link.download = `${doc.document_number}.pdf`;
                                  document.body.appendChild(link);
                                  link.click();
                                  document.body.removeChild(link);
                                  URL.revokeObjectURL(url);
                                } catch {
                                  toast.error(
                                    "Impossible de télécharger le document.",
                                  );
                                }
                              }}
                              className={`px-3 py-1.5 rounded text-sm font-medium transition ${isDark ? "bg-rose-500 hover:bg-rose-600" : "bg-rose-600 hover:bg-rose-700"} text-white`}
                            >
                              ⬇️ PDF
                            </button>
                            <button
                              onClick={async () => {
                                if (
                                  !window.confirm(
                                    `Supprimer ${doc.document_number} ?`,
                                  )
                                )
                                  return;
                                try {
                                  await api.delete(
                                    `/admin/billing-documents/${doc.id_billing_document}`,
                                  );
                                  setAdminBillingDocs((prev) =>
                                    prev.filter(
                                      (d) =>
                                        d.id_billing_document !==
                                        doc.id_billing_document,
                                    ),
                                  );
                                  toast.success("Document supprimé.");
                                } catch {
                                  toast.error(
                                    "Impossible de supprimer le document.",
                                  );
                                }
                              }}
                              className={`px-3 py-1.5 rounded text-sm font-medium transition ${isDark ? "bg-white/10 hover:bg-red-900/40 text-red-400" : "bg-gray-100 hover:bg-red-50 text-red-600"}`}
                              title="Supprimer"
                            >
                              🗑️
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  );
                })()
              )}
            </div>
          </div>
        )}
        {activeTab === "deliveries" && (
          <div className="space-y-6">
            <h2 className="text-xl font-semibold">Livraisons de fichiers</h2>

            {/* Formulaire d'upload */}
            <div className={`p-6 rounded-xl border ${isDark ? "bg-[#0b0b0c] border-white/10" : "bg-white border-gray-200"}`}>
              <h3 className={`font-semibold mb-4 ${isDark ? "text-white" : "text-gray-800"}`}>
                📤 Envoyer un fichier à un client
              </h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                <div>
                  <label className={`block text-sm font-medium mb-1 ${isDark ? "text-white/70" : "text-gray-600"}`}>
                    Client *
                  </label>
                  <select
                    value={deliveryForm.clientId}
                    onChange={(e) => setDeliveryForm((p) => ({ ...p, clientId: e.target.value }))}
                    className={`w-full px-3 py-2 rounded-lg border text-sm ${isDark ? "bg-[#0b0b0c] border-white/10 text-white" : "bg-white border-gray-300 text-gray-800"}`}
                  >
                    <option value="">-- Sélectionner un client --</option>
                    {users.filter((u) => u.id_role !== 3).map((u) => (
                      <option key={u.id_user} value={u.id_user}>
                        {u.firstname || u.lastname ? `${u.firstname || ""} ${u.lastname || ""}`.trim() : u.email} ({u.email})
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className={`block text-sm font-medium mb-1 ${isDark ? "text-white/70" : "text-gray-600"}`}>
                    Libellé (description)
                  </label>
                  <input
                    type="text"
                    value={deliveryForm.label}
                    onChange={(e) => setDeliveryForm((p) => ({ ...p, label: e.target.value }))}
                    placeholder="Ex: Maquette finale v2, Sources du projet…"
                    className={`w-full px-3 py-2 rounded-lg border text-sm ${isDark ? "bg-[#0b0b0c] border-white/10 text-white placeholder-white/30" : "bg-white border-gray-300 text-gray-800"}`}
                  />
                </div>
              </div>
              <div className="mb-4">
                <label className={`block text-sm font-medium mb-1 ${isDark ? "text-white/70" : "text-gray-600"}`}>
                  Fichier * (max 100 Mo)
                </label>
                <div
                  onClick={() => deliveryFileInputRef.current?.click()}
                  className={`flex items-center gap-3 px-4 py-3 rounded-lg border-2 border-dashed cursor-pointer transition ${isDark ? "border-white/20 hover:border-white/40 text-white/60" : "border-gray-300 hover:border-gray-400 text-gray-500"}`}
                >
                  <span className="text-2xl">📂</span>
                  <span className="text-sm">
                    {deliveryForm.file ? deliveryForm.file.name : "Cliquer pour choisir un fichier…"}
                  </span>
                  {deliveryForm.file && (
                    <button
                      type="button"
                      onClick={(e) => { e.stopPropagation(); setDeliveryForm((p) => ({ ...p, file: null })); if (deliveryFileInputRef.current) deliveryFileInputRef.current.value = ""; }}
                      className="ml-auto text-red-400 hover:text-red-500"
                    >✕</button>
                  )}
                </div>
                <input
                  ref={deliveryFileInputRef}
                  type="file"
                  className="hidden"
                  onChange={(e) => {
                    const f = e.target.files?.[0] || null;
                    setDeliveryForm((p) => ({ ...p, file: f }));
                  }}
                />
              </div>
              <button
                type="button"
                disabled={deliveryUploading || !deliveryForm.clientId || !deliveryForm.file}
                onClick={async () => {
                  if (!deliveryForm.clientId || !deliveryForm.file) return;
                  try {
                    setDeliveryUploading(true);
                    const fd = new FormData();
                    fd.append("id_user_client", deliveryForm.clientId);
                    fd.append("label", deliveryForm.label || "");
                    fd.append("file", deliveryForm.file);
                    const res = await api.post("/admin/delivery-files", fd, {
                      headers: { "Content-Type": "multipart/form-data" },
                    });
                    if (res.data?.success) {
                      toast.success("Fichier livré avec succès !");
                      setDeliveryFiles((prev) => [res.data.data, ...prev]);
                      setDeliveryForm({ clientId: "", label: "", file: null });
                      if (deliveryFileInputRef.current) deliveryFileInputRef.current.value = "";
                    } else {
                      toast.error(res.data?.message || "Erreur lors de l'envoi.");
                    }
                  } catch (err) {
                    console.error("Erreur upload livraison:", err);
                    toast.error(err?.response?.data?.message || "Impossible d'envoyer le fichier.");
                  } finally {
                    setDeliveryUploading(false);
                  }
                }}
                className="px-5 py-2 rounded-lg font-semibold text-white transition disabled:opacity-50"
                style={{ background: "linear-gradient(135deg, #f43f5e 0%, #a855f7 50%, #6366f1 100%)" }}
              >
                {deliveryUploading ? "Envoi en cours…" : "📤 Livrer le fichier"}
              </button>
            </div>

            {/* Liste des fichiers livrés */}
            <div className={`p-6 rounded-xl border ${isDark ? "bg-[#0b0b0c] border-white/10" : "bg-white border-gray-200"}`}>
              <h3 className={`font-semibold mb-4 ${isDark ? "text-white" : "text-gray-800"}`}>
                📦 Fichiers envoyés ({deliveryFiles.length})
              </h3>
              {deliveryFilesLoading ? (
                <p className={isDark ? "text-white/50" : "text-gray-500"}>Chargement…</p>
              ) : deliveryFiles.length === 0 ? (
                <p className={isDark ? "text-white/50" : "text-gray-500"}>Aucun fichier livré pour le moment.</p>
              ) : (
                <div className="space-y-3">
                  {deliveryFiles.map((f) => (
                    <div
                      key={f.id}
                      className={`p-4 rounded-lg border flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 ${isDark ? "bg-white/5 border-white/10" : "bg-gray-50 border-gray-200"}`}
                    >
                      <div className="flex-1 min-w-0">
                        <p className="font-semibold truncate">{f.label || f.original_filename}</p>
                        <p className={`text-sm truncate ${isDark ? "text-white/60" : "text-gray-500"}`}>
                          📧 {f.client_email} · 📄 {f.original_filename}
                        </p>
                        <p className={`text-xs mt-1 ${isDark ? "text-white/40" : "text-gray-400"}`}>
                          {f.file_size} · Livré le {f.created_at} · {f.download_count} téléchargement(s)
                        </p>
                      </div>
                      <button
                        type="button"
                        onClick={async () => {
                          if (!window.confirm(`Supprimer le fichier "${f.label || f.original_filename}" ?`)) return;
                          try {
                            await api.delete(`/admin/delivery-files/${f.id}`);
                            setDeliveryFiles((prev) => prev.filter((x) => x.id !== f.id));
                            toast.success("Fichier supprimé.");
                          } catch {
                            toast.error("Impossible de supprimer le fichier.");
                          }
                        }}
                        className={`px-3 py-1.5 rounded text-sm font-medium transition shrink-0 ${isDark ? "bg-white/10 hover:bg-red-900/40 text-red-400" : "bg-gray-100 hover:bg-red-50 text-red-600"}`}
                      >
                        🗑️ Supprimer
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}

        {activeTab === "settings" && (
          <div className="space-y-6">
            <h2 className="text-xl font-semibold">Réglages du site</h2>

            {siteSettingsLoading ? (
              <div
                className={`p-6 rounded-xl border ${isDark ? "bg-[#0b0b0c] border-white/10" : "bg-white border-gray-200"}`}
              >
                <p className={isDark ? "text-gray-400" : "text-gray-500"}>
                  Chargement des paramètres...
                </p>
              </div>
            ) : (
              <>
                {/* Mode maintenance */}
                <div
                  className={`p-6 rounded-xl border ${isDark ? "bg-[#0b0b0c] border-white/10" : "bg-white border-gray-200"}`}
                >
                  <div className="flex items-center justify-between">
                    <div>
                      <h3 className="text-base font-semibold flex items-center gap-2">
                        <Power className="w-4 h-4 text-orange-500" />
                        Mode maintenance
                      </h3>
                      <p
                        className={`text-sm mt-1 ${isDark ? "text-gray-400" : "text-gray-500"}`}
                      >
                        Active le mode maintenance — les utilisateurs voient une
                        page d'indisponibilité.
                      </p>
                    </div>
                    <button
                      type="button"
                      onClick={() =>
                        setSiteSettings((prev) => ({
                          ...prev,
                          maintenance_mode: !prev.maintenance_mode,
                        }))
                      }
                      className={`relative inline-flex h-7 w-12 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 focus:outline-none ${
                        siteSettings.maintenance_mode
                          ? "bg-orange-500"
                          : isDark
                            ? "bg-white/10"
                            : "bg-gray-200"
                      }`}
                    >
                      <span
                        className={`inline-block h-6 w-6 transform rounded-full bg-white shadow transition-transform duration-200 ${
                          siteSettings.maintenance_mode
                            ? "translate-x-5"
                            : "translate-x-0"
                        }`}
                      />
                    </button>
                  </div>
                  {siteSettings.maintenance_mode && (
                    <div
                      className={`mt-4 p-3 rounded-lg text-sm ${isDark ? "bg-orange-500/10 border border-orange-500/30 text-orange-300" : "bg-orange-50 border border-orange-200 text-orange-700"}`}
                    >
                      ⚠️ Le mode maintenance est <strong>activé</strong> — le
                      site est inaccessible aux visiteurs.
                    </div>
                  )}
                </div>

                {/* Rôles bloqués */}
                <div
                  className={`p-6 rounded-xl border ${isDark ? "bg-[#0b0b0c] border-white/10" : "bg-white border-gray-200"}`}
                >
                  <h3 className="text-base font-semibold mb-1">
                    Rôles bloqués
                  </h3>
                  <p
                    className={`text-sm mb-4 ${isDark ? "text-gray-400" : "text-gray-500"}`}
                  >
                    Les utilisateurs appartenant à un rôle bloqué ne peuvent
                    plus se connecter.
                  </p>
                  <div className="space-y-3">
                    {[{ id: 1, label: "Clients (rôle 1)" }].map((role) => {
                      const isBlocked = Array.isArray(
                        siteSettings.blocked_roles,
                      )
                        ? siteSettings.blocked_roles
                            .map(Number)
                            .includes(role.id)
                        : false;
                      return (
                        <div
                          key={role.id}
                          className={`flex items-center justify-between p-4 rounded-lg border ${
                            isBlocked
                              ? isDark
                                ? "bg-red-500/10 border-red-500/30"
                                : "bg-red-50 border-red-200"
                              : isDark
                                ? "bg-white/5 border-white/10"
                                : "bg-gray-50 border-gray-200"
                          }`}
                        >
                          <div className="flex items-center gap-3">
                            <div
                              className={`w-2 h-2 rounded-full ${isBlocked ? "bg-red-500" : "bg-green-500"}`}
                            />
                            <span className="font-medium">{role.label}</span>
                            <span
                              className={`text-xs px-2 py-0.5 rounded-full ${isBlocked ? (isDark ? "bg-red-500/20 text-red-400" : "bg-red-100 text-red-700") : isDark ? "bg-green-500/20 text-green-400" : "bg-green-100 text-green-700"}`}
                            >
                              {isBlocked ? "Bloqué" : "Actif"}
                            </span>
                          </div>
                          <button
                            type="button"
                            onClick={() => handleToggleBlockedRole(role.id)}
                            className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${
                              isBlocked
                                ? "bg-green-500/10 text-green-500 hover:bg-green-500/20"
                                : "bg-red-500/10 text-red-500 hover:bg-red-500/20"
                            }`}
                          >
                            {isBlocked ? "Débloquer" : "Bloquer"}
                          </button>
                        </div>
                      );
                    })}
                  </div>
                </div>

                {/* Bouton sauvegarder */}
                <div className="flex justify-end">
                  <button
                    type="button"
                    onClick={handleSaveSiteSettings}
                    disabled={siteSettingsSaving}
                    className={`px-6 py-2.5 rounded-lg font-semibold text-white transition-colors ${
                      siteSettingsSaving
                        ? "opacity-60 cursor-not-allowed bg-rose-500"
                        : "bg-rose-500 hover:bg-rose-600"
                    }`}
                  >
                    {siteSettingsSaving
                      ? "Enregistrement..."
                      : "Enregistrer les réglages"}
                  </button>
                </div>
              </>
            )}
          </div>
        )}
      </div>

      {/* Modals */}

      {/* Modal Utilisateur */}
      <ModalAdmin
        isOpen={userModalOpen}
        onClose={() => setUserModalOpen(false)}
        title={
          userFormMode === "create"
            ? "Créer un utilisateur"
            : userFormMode === "edit"
              ? "Modifier l'utilisateur"
              : "Détails de l'utilisateur"
        }
        size="md"
      >
        {userFormMode === "view" && selectedUser ? (
          <div>
            <label
              className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
            >
              Pseudo
            </label>
            <p className={isDark ? "text-white" : "text-gray-800"}>
              {selectedUser.nickname}
            </p>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label
                  className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
                >
                  Prénom
                </label>
                <p className={isDark ? "text-white" : "text-gray-800"}>
                  {selectedUser.firstname}
                </p>
              </div>
              <div>
                <label
                  className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
                >
                  Nom
                </label>
                <p className={isDark ? "text-white" : "text-gray-800"}>
                  {selectedUser.lastname}
                </p>
              </div>
            </div>
            <div>
              <label
                className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
              >
                Email
              </label>
              <p className={isDark ? "text-white" : "text-gray-800"}>
                {selectedUser.email}
              </p>
            </div>
            <div>
              <label
                className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
              >
                Rôle
              </label>
              <p className={isDark ? "text-white" : "text-gray-800"}>
                {selectedUser.id_role === 3 ? "Admin" : "Client"}
              </p>
            </div>
            <div>
              <label
                className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
              >
                Vérification email
              </label>
              <p
                className={
                  selectedUser.email_verified_at
                    ? "text-green-500"
                    : "text-orange-500"
                }
              >
                {selectedUser.email_verified_at ? "✓ Vérifié" : "⏳ En attente"}
              </p>
            </div>
            <div>
              <label
                className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
              >
                Statut du compte
              </label>
              <div className="flex items-center justify-between">
                <p
                  className={
                    selectedUser.status === "active"
                      ? "text-green-500"
                      : "text-red-500"
                  }
                >
                  {selectedUser.status === "active" ? "✓ Actif" : "✕ Inactif"}
                </p>
                <button
                  onClick={async () => {
                    const newStatus =
                      selectedUser.status === "active" ? "inactive" : "active";
                    try {
                      await api.put(
                        `/admin/users/${selectedUser.id_user || selectedUser.id}`,
                        {
                          ...selectedUser,
                          status: newStatus,
                        },
                      );
                      toast.success(
                        `Utilisateur ${newStatus === "active" ? "activé" : "désactivé"}`,
                      );
                      setSelectedUser({ ...selectedUser, status: newStatus });
                      fetchUsers();
                    } catch (error) {
                      toast.error("Erreur lors du changement de statut");
                    }
                  }}
                  className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${
                    selectedUser.status === "active"
                      ? "bg-red-500/10 text-red-500 hover:bg-red-500/20"
                      : "bg-green-500/10 text-green-500 hover:bg-green-500/20"
                  }`}
                >
                  {selectedUser.status === "active" ? "Désactiver" : "Activer"}
                </button>
              </div>
            </div>
            <div>
              <label
                className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
              >
                Date d'inscription
              </label>
              <p className={isDark ? "text-white" : "text-gray-800"}>
                {new Date(selectedUser.created_at).toLocaleDateString("fr-FR")}
              </p>
            </div>
          </div>
        ) : (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              const formData = new FormData(e.target);
              const userData = {
                nickname: formData.get("nickname"),
                firstname: formData.get("firstname"),
                lastname: formData.get("lastname"),
                email: formData.get("email"),
                id_role: parseInt(formData.get("role")),
                status: formData.get("status"),
              };

              // Ajouter le mot de passe uniquement si fourni
              const password = formData.get("password");
              if (password && password.trim()) {
                userData.password = password;
              }

              handleSaveUser(userData);
            }}
            className="space-y-4"
          >
            <div>
              <label
                className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
              >
                Pseudo *
              </label>
              <input
                type="text"
                name="nickname"
                defaultValue={selectedUser?.nickname || ""}
                required
                className={`w-full px-3 py-2 rounded-lg border ${isDark ? "bg-[#0b0b0c] border-white/10 text-white" : "bg-white border-gray-200 text-gray-800"}`}
              />
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label
                  className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
                >
                  Prénom *
                </label>
                <input
                  type="text"
                  name="firstname"
                  defaultValue={selectedUser?.firstname || ""}
                  required
                  className={`w-full px-3 py-2 rounded-lg border ${isDark ? "bg-[#0b0b0c] border-white/10 text-white" : "bg-white border-gray-200 text-gray-800"}`}
                />
              </div>
              <div>
                <label
                  className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
                >
                  Nom *
                </label>
                <input
                  type="text"
                  name="lastname"
                  defaultValue={selectedUser?.lastname || ""}
                  required
                  className={`w-full px-3 py-2 rounded-lg border ${isDark ? "bg-[#0b0b0c] border-white/10 text-white" : "bg-white border-gray-200 text-gray-800"}`}
                />
              </div>
            </div>
            <div>
              <label
                className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
              >
                Email *
              </label>
              <input
                type="email"
                name="email"
                defaultValue={selectedUser?.email || ""}
                required
                className={`w-full px-3 py-2 rounded-lg border ${isDark ? "bg-[#0b0b0c] border-white/10 text-white" : "bg-white border-gray-200 text-gray-800"}`}
              />
              {userFormMode === "edit" && (
                <p
                  className={`text-xs mt-1 ${isDark ? "text-orange-400" : "text-orange-600"}`}
                >
                  ⚠️ Modifier l'email désactivera le compte jusqu'à vérification
                </p>
              )}
            </div>
            <div>
              <label
                className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
              >
                Rôle *
              </label>
              <select
                name="role"
                defaultValue={selectedUser?.id_role || 1}
                className={`w-full px-3 py-2 rounded-lg border ${isDark ? "bg-[#0b0b0c] border-white/10 text-white" : "bg-white border-gray-200 text-gray-800"}`}
              >
                <option value="1">Utilisateur</option>
                <option value="2">Créateur</option>
                <option value="3">Admin</option>
              </select>
            </div>
            <div>
              <label
                className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
              >
                Statut du compte *
              </label>
              <select
                name="status"
                defaultValue={selectedUser?.status || "active"}
                className={`w-full px-3 py-2 rounded-lg border ${isDark ? "bg-[#0b0b0c] border-white/10 text-white" : "bg-white border-gray-200 text-gray-800"}`}
              >
                <option value="active">Actif</option>
                <option value="inactive">Inactif</option>
              </select>
              {userFormMode === "edit" &&
                selectedUser?.status === "inactive" && (
                  <p
                    className={`text-xs mt-1 ${isDark ? "text-red-400" : "text-red-600"}`}
                  >
                    ⚠️ Cet utilisateur ne pourra pas se connecter
                  </p>
                )}
            </div>
            <div>
              <input
                type="password"
                name="password"
                required={userFormMode === "create"}
                placeholder={
                  userFormMode === "edit"
                    ? "Laisser vide pour ne pas modifier"
                    : ""
                }
                minLength={8}
                className={`w-full px-3 py-2 rounded-lg border ${isDark ? "bg-[#0b0b0c] border-white/10 text-white" : "bg-white border-gray-200 text-gray-800"}`}
              />
              <p
                className={`text-xs mt-1 ${isDark ? "text-gray-500" : "text-gray-400"}`}
              >
                Minimum 8 caractères
              </p>
            </div>
            <div className="flex gap-2 justify-end pt-4">
              <button
                type="button"
                onClick={() => setUserModalOpen(false)}
                className={`px-4 py-2 rounded-lg border ${isDark ? "border-white/10 hover:bg-white/5" : "border-gray-200 hover:bg-gray-50"}`}
              >
                Annuler
              </button>
              <button
                type="submit"
                className="px-4 py-2 bg-rose-500 text-white rounded-lg hover:bg-rose-600"
              >
                {userFormMode === "create" ? "Créer" : "Modifier"}
              </button>
            </div>
          </form>
        )}
      </ModalAdmin>

      {/* Modal Commande */}
      <ModalAdmin
        isOpen={orderModalOpen}
        onClose={() => setOrderModalOpen(false)}
        title="Détails de la commande"
        size="lg"
      >
        {selectedOrder && (
          <div className="space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label
                  className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
                >
                  N° Commande
                </label>
                <p className="font-semibold">{selectedOrder.order_id}</p>
              </div>
              <div>
                <label
                  className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
                >
                  Date
                </label>
                <p>{selectedOrder.date}</p>
              </div>
              <div>
                <label
                  className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
                >
                  Client
                </label>
                <p>{selectedOrder.client}</p>
              </div>
              <div>
                <label
                  className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
                >
                  Service
                </label>
                <p>{selectedOrder.service}</p>
              </div>
              <div>
                <label
                  className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
                >
                  Montant
                </label>
                <p className="text-lg font-semibold text-rose-500">
                  {selectedOrder.amount}€
                </p>
              </div>
              <div>
                <label
                  className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
                >
                  Statut
                </label>
                <select
                  defaultValue={selectedOrder.status}
                  className={`w-full px-3 py-2 rounded-lg border ${isDark ? "bg-[#0b0b0c] border-white/10" : "bg-white border-gray-200"}`}
                >
                  <option>Nouveau</option>
                  <option>En cours</option>
                  <option>Complété</option>
                  <option>Annulé</option>
                </select>
              </div>
            </div>
            <div className="flex gap-2 justify-end pt-4 border-t">
              <button
                onClick={() => setOrderModalOpen(false)}
                className={`px-4 py-2 rounded-lg border ${isDark ? "border-white/10 hover:bg-white/5" : "border-gray-200 hover:bg-gray-50"}`}
              >
                Fermer
              </button>
              <button className="px-4 py-2 bg-rose-500 text-white rounded-lg hover:bg-rose-600">
                Enregistrer
              </button>
            </div>
          </div>
        )}
      </ModalAdmin>

      {/* Modal Message */}
      <ModalAdmin
        isOpen={messageModalOpen}
        onClose={() => setMessageModalOpen(false)}
        title="Message de contact"
        size="md"
      >
        {selectedMessage && (
          <div className="space-y-4">
            <div>
              <label
                className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
              >
                Nom
              </label>
              <p>{selectedMessage.name}</p>
            </div>
            <div>
              <label
                className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
              >
                Email
              </label>
              <p>{selectedMessage.email}</p>
            </div>
            <div>
              <label
                className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
              >
                Sujet
              </label>
              <p className="font-semibold">{selectedMessage.subject}</p>
            </div>
            {selectedMessage.request_type && (
              <div>
                <label
                  className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
                >
                  Type de demande
                </label>
                <span
                  className={`inline-block px-3 py-1 text-sm rounded-full ${
                    selectedMessage.request_type === "support"
                      ? isDark
                        ? "bg-blue-500/20 text-blue-400"
                        : "bg-blue-100 text-blue-700"
                      : selectedMessage.request_type === "creation"
                        ? isDark
                          ? "bg-purple-500/20 text-purple-400"
                          : "bg-purple-100 text-purple-700"
                        : isDark
                          ? "bg-gray-500/20 text-gray-400"
                          : "bg-gray-100 text-gray-700"
                  }`}
                >
                  {selectedMessage.request_type === "support"
                    ? "Support / Assistance"
                    : selectedMessage.request_type === "creation"
                      ? "Demande de création"
                      : "Autre"}
                </span>
              </div>
            )}
            <div>
              <label
                className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
              >
                Message
              </label>
              <p
                className={`p-3 rounded-lg ${isDark ? "bg-[#0b0b0c] border border-white/10" : "bg-gray-50 border border-gray-200"}`}
              >
                {selectedMessage.message}
              </p>
            </div>

            {/* Fil de conversation */}
            {selectedMessage.replies && selectedMessage.replies.length > 0 && (
              <div>
                <label
                  className={`block text-sm font-medium mb-2 ${isDark ? "text-gray-400" : "text-gray-600"}`}
                >
                  Fil de discussion
                </label>
                <div className="space-y-2 max-h-48 overflow-y-auto pr-1">
                  {selectedMessage.replies.map((r) => {
                    const isAdmin = !r.id_user || r.name === "Krayne Agency";
                    return (
                      <div
                        key={r.id}
                        className={`p-3 rounded-lg border text-sm ${
                          isAdmin
                            ? isDark
                              ? "bg-blue-500/5 border-blue-500/20"
                              : "bg-blue-50 border-blue-200"
                            : isDark
                              ? "bg-white/5 border-white/10"
                              : "bg-gray-50 border-gray-200"
                        }`}
                      >
                        <p
                          className={`text-xs font-bold mb-1 ${isAdmin ? (isDark ? "text-blue-400" : "text-blue-700") : isDark ? "text-gray-400" : "text-gray-600"}`}
                        >
                          {isAdmin ? "Krayne Agency" : r.name}
                        </p>
                        <p className="whitespace-pre-wrap">{r.message}</p>
                        <p
                          className={`text-xs mt-1 ${isDark ? "text-white/30" : "text-gray-400"}`}
                        >
                          {new Date(r.created_at).toLocaleDateString("fr-FR", {
                            day: "numeric",
                            month: "short",
                            hour: "2-digit",
                            minute: "2-digit",
                          })}
                        </p>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

            <div>
              <label
                className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
              >
                Répondre
              </label>
              <textarea
                value={replyText}
                onChange={(e) => setReplyText(e.target.value)}
                rows="4"
                className={`w-full px-3 py-2 rounded-lg border resize-none ${isDark ? "bg-[#0b0b0c] border-white/10 text-white" : "bg-white border-gray-200 text-gray-800"}`}
                placeholder="Saisissez votre réponse..."
              />
            </div>
            <div>
              <label
                className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
              >
                Date
              </label>
              <p>{selectedMessage.created_at}</p>
            </div>
            <div className="flex gap-2 justify-end pt-4 border-t">
              <button
                onClick={() => setMessageModalOpen(false)}
                className={`px-4 py-2 rounded-lg border ${isDark ? "border-white/10 hover:bg-white/5" : "border-gray-200 hover:bg-gray-50"}`}
              >
                Fermer
              </button>
              <button
                onClick={handleReplyMessage}
                className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
              >
                Répondre
              </button>
            </div>
          </div>
        )}
      </ModalAdmin>

      {/* Modal Produit */}
      <ModalAdmin
        isOpen={productModalOpen}
        onClose={() => {
          setProductModalOpen(false);
          setUploadedImages([]);
          setImagePreviews([]);
          setProductFiles([]);
        }}
        title={
          productFormMode === "create"
            ? "Créer une réalisation"
            : productFormMode === "edit"
              ? "Modifier la réalisation"
              : "Détails de la réalisation"
        }
        size="lg"
      >
        {productFormMode !== "view" ? (
          <form
            key={`${productFormMode}-${selectedProduct?.id_product || selectedProduct?.id || "new"}`}
            onSubmit={(e) => {
              e.preventDefault();
              const formData = new FormData(e.target);
              const link = String(formData.get("link") || "").trim();
              const idUserClient = formData.get("id_user_client");
              handleSaveProduct({
                name: formData.get("name"),
                category: selectedCategory,
                price: 0,
                stock: 0,
                sale_type: "libre",
                description: formData.get("description"),
                status: formData.get("status"),
                creator_type: formData.get("creator_type"),
                id_user_creator: formData.get("id_user_creator") || null,
                creator_name: formData.get("creator_name") || null,
                id_user_client: idUserClient
                  ? parseInt(idUserClient, 10)
                  : null,
                link,
              });
            }}
            className="space-y-4"
          >
            {productFormMode === "edit" && selectedProduct && (
              <div
                className={`rounded-2xl border p-4 ${isDark ? "border-white/10 bg-white/5" : "border-gray-200 bg-gradient-to-br from-white to-gray-50"}`}
              >
                <div className="flex flex-wrap items-start justify-between gap-4">
                  <div>
                    <p
                      className={`text-xs font-semibold uppercase tracking-[0.2em] ${isDark ? "text-gray-400" : "text-gray-500"}`}
                    >
                      Résumé de la réalisation
                    </p>
                    <h3 className="mt-2 text-lg font-semibold">
                      {selectedProduct?.name || "Réalisation en cours"}
                    </h3>
                    <p
                      className={`mt-1 text-sm ${isDark ? "text-gray-400" : "text-gray-600"}`}
                    >
                      Retrouvez ici la categorie, les visuels et les fichiers
                      deja rattaches pour modifier rapidement la fiche.
                    </p>
                  </div>
                  <div className="flex flex-wrap gap-2">
                    <span
                      className={`rounded-full px-3 py-1 text-xs font-semibold ${isDark ? "bg-white/10 text-white/80" : "bg-white text-gray-700 border border-gray-200"}`}
                    >
                      {selectedCategory ||
                        selectedProduct?.category ||
                        "Sans categorie"}
                    </span>
                    <span
                      className={`rounded-full px-3 py-1 text-xs font-semibold ${productSaleType === "unique" ? (isDark ? "bg-purple-500/15 text-purple-200 border border-purple-500/20" : "bg-purple-50 text-purple-700 border border-purple-200") : isDark ? "bg-blue-500/15 text-blue-200 border border-blue-500/20" : "bg-blue-50 text-blue-700 border border-blue-200"}`}
                    >
                      {productSaleType === "unique"
                        ? "Vente unique"
                        : "Vente libre"}
                    </span>
                  </div>
                </div>

                <div className="mt-4 grid gap-3 sm:grid-cols-2 xl:grid-cols-4">
                  <div
                    className={`rounded-xl border p-3 ${isDark ? "border-white/10 bg-[#0b0b0c]" : "border-gray-200 bg-white"}`}
                  >
                    <p
                      className={`text-xs uppercase tracking-[0.18em] ${isDark ? "text-gray-500" : "text-gray-500"}`}
                    >
                      Categorie
                    </p>
                    <p className="mt-2 font-semibold">
                      {selectedCategory ||
                        selectedProduct?.category ||
                        "A definir"}
                    </p>
                  </div>
                  <div
                    className={`rounded-xl border p-3 ${isDark ? "border-white/10 bg-[#0b0b0c]" : "border-gray-200 bg-white"}`}
                  >
                    <p
                      className={`text-xs uppercase tracking-[0.18em] ${isDark ? "text-gray-500" : "text-gray-500"}`}
                    >
                      Visuels
                    </p>
                    <p className="mt-2 font-semibold">
                      {Array.isArray(selectedProduct?.images) &&
                      selectedProduct.images.length > 0
                        ? `${selectedProduct.images.length} image(s)`
                        : resolveProductImageUrl(selectedProduct)
                          ? "1 image"
                          : "Aucune image"}
                    </p>
                  </div>
                  <div
                    className={`rounded-xl border p-3 ${isDark ? "border-white/10 bg-[#0b0b0c]" : "border-gray-200 bg-white"}`}
                  >
                    <p
                      className={`text-xs uppercase tracking-[0.18em] ${isDark ? "text-gray-500" : "text-gray-500"}`}
                    >
                      Fichiers
                    </p>
                    <p className="mt-2 font-semibold">
                      {Array.isArray(selectedProduct?.downloadable_files) &&
                      selectedProduct.downloadable_files.length > 0
                        ? `${selectedProduct.downloadable_files.length} fichier(s)`
                        : "Aucun fichier"}
                    </p>
                  </div>
                  <div
                    className={`rounded-xl border p-3 ${isDark ? "border-white/10 bg-[#0b0b0c]" : "border-gray-200 bg-white"}`}
                  >
                    <p
                      className={`text-xs uppercase tracking-[0.18em] ${isDark ? "text-gray-500" : "text-gray-500"}`}
                    >
                      Statut
                    </p>
                    <p className="mt-2 font-semibold">
                      {selectedProduct?.status === "active"
                        ? "Actif"
                        : "Inactif"}
                    </p>
                  </div>
                </div>
              </div>
            )}

            <div className="grid grid-cols-2 gap-4">
              <div>
                <label
                  className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
                >
                  Nom de la réalisation<span className="text-rose-500">*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  defaultValue={productFormValues?.name || ""}
                  required
                  className={`w-full px-3 py-2 rounded-lg border ${isDark ? "bg-[#0b0b0c] border-white/10 text-white" : "bg-white border-gray-200 text-gray-800"}`}
                />
              </div>
              <div>
                <label
                  className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
                >
                  Catégorie <span className="text-rose-500">*</span>
                </label>
                <input
                  type="text"
                  name="category_input"
                  list="categories-datalist"
                  value={selectedCategory}
                  onChange={(e) => setSelectedCategory(e.target.value)}
                  placeholder="Sélectionner ou saisir une catégorie"
                  required
                  className={`w-full px-3 py-2 rounded-lg border ${isDark ? "bg-[#0b0b0c] border-white/10 text-white" : "bg-white border-gray-200 text-gray-800"}`}
                />
                <datalist id="categories-datalist">
                  {categories.map((cat) => (
                    <option
                      key={cat.id_category || cat.id}
                      value={cat.name || cat.name_category}
                    />
                  ))}
                </datalist>
                <div className="mt-2 flex flex-wrap gap-2">
                  <span
                    className={`rounded-full px-3 py-1 text-xs font-medium ${isDark ? "bg-white/5 text-white/75 border border-white/10" : "bg-gray-100 text-gray-700 border border-gray-200"}`}
                  >
                    Selection actuelle :{" "}
                    {selectedCategory || "Aucune categorie"}
                  </span>
                </div>
              </div>
            </div>

            {/* Champs prix, TVA, type de vente, statut retirés — formulaire réalisation uniquement */}

            {false && (
              <div
                className={`p-5 rounded-lg border-2 ${isDark ? "border-purple-500/40 bg-gradient-to-br from-purple-500/10 to-purple-500/5" : "border-purple-300 bg-gradient-to-br from-purple-50 to-purple-25"}`}
              >
                {/* Header avec icône */}
                <div className="flex items-center gap-2 mb-4">
                  <svg
                    className="w-5 h-5 text-purple-500"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <h3
                    className={`text-sm font-semibold ${isDark ? "text-gray-100" : "text-gray-800"}`}
                  >
                    Utilisateurs autorisés{" "}
                    <span className="text-purple-500">*</span>
                  </h3>
                </div>

                {/* Description */}
                <p
                  className={`text-xs mb-4 ${isDark ? "text-gray-400" : "text-gray-600"}`}
                >
                  <span className="font-semibold text-purple-500">
                    ⚠️ Vente unique :
                  </span>{" "}
                  Sélectionnez UN SEUL utilisateur qui pourra voir et acheter
                  cette création exclusive.
                </p>

                {/* Bouton désélectionner */}
                {allowedUsers.length > 0 && (
                  <div className="mb-4">
                    <button
                      type="button"
                      onClick={() => setAllowedUsers([])}
                      className={`text-xs px-3 py-1.5 rounded font-medium transition-all ${isDark ? "bg-gray-700 hover:bg-gray-600 text-gray-200" : "bg-gray-200 hover:bg-gray-300 text-gray-700"}`}
                    >
                      ✕ Désélectionner
                    </button>
                  </div>
                )}

                {/* Résumé des sélectionnés */}
                {allowedUsers.length > 0 && (
                  <div
                    className={`mb-4 p-3 rounded-lg ${isDark ? "bg-purple-500/10 border border-purple-500/30" : "bg-purple-50 border border-purple-200"}`}
                  >
                    <p
                      className={`text-sm font-semibold ${isDark ? "text-purple-200" : "text-purple-700"}`}
                    >
                      ✓ {allowedUsers.length} utilisateur
                      {allowedUsers.length > 1 ? "s" : ""} sélectionné
                      {allowedUsers.length > 1 ? "s" : ""}
                    </p>
                    <div
                      className={`mt-2 ${isDark ? "text-gray-300" : "text-gray-700"}`}
                    >
                      {allowedUsers.map((userId, idx) => {
                        const user = users.find(
                          (u) => String(u.id_user || u.id) === userId,
                        );
                        const label = user
                          ? user.nickname ||
                            `${user.firstname ?? ""} ${user.lastname ?? ""}`.trim() ||
                            user.email
                          : "";
                        return (
                          <div key={userId} className="text-sm">
                            • {label}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}

                {/* Liste des utilisateurs */}
                <div
                  className="max-h-60 overflow-y-auto border rounded-lg p-3 pr-2"
                  style={{
                    backgroundColor: isDark
                      ? "rgba(255,255,255,0.02)"
                      : "rgba(255,255,255,0.6)",
                    borderColor: isDark
                      ? "rgba(255,255,255,0.1)"
                      : "rgba(0,0,0,0.1)",
                  }}
                >
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                    {users.map((u) => {
                      const id = u.id_user || u.id;
                      const label =
                        u.nickname ||
                        `${u.firstname ?? ""} ${u.lastname ?? ""}`.trim() ||
                        u.email;
                      const checked = allowedUsers.includes(String(id));
                      return (
                        <label
                          key={id}
                          className={`flex items-center gap-3 p-3 rounded-lg border-2 cursor-pointer transition-all ${
                            checked
                              ? isDark
                                ? "bg-purple-500/15 border-purple-500/50"
                                : "bg-purple-50 border-purple-300"
                              : isDark
                                ? "bg-white/2 border-white/10 hover:bg-white/5"
                                : "bg-white/30 border-gray-200 hover:bg-gray-50"
                          }`}
                        >
                          <div
                            className={`w-5 h-5 rounded-md border-2 flex items-center justify-center flex-shrink-0 transition-colors ${
                              checked
                                ? isDark
                                  ? "bg-purple-500/40 border-purple-500"
                                  : "bg-purple-500 border-purple-500"
                                : isDark
                                  ? "border-gray-600"
                                  : "border-gray-300"
                            }`}
                          >
                            {checked && (
                              <svg
                                className={`w-3 h-3 ${isDark ? "text-purple-200" : "text-white"}`}
                                fill="currentColor"
                                viewBox="0 0 20 20"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            )}
                          </div>
                          <input
                            type="radio"
                            name="unique_user"
                            checked={checked}
                            onChange={() => {
                              // Pour une vente unique, un seul utilisateur peut être sélectionné
                              setAllowedUsers([String(id)]);
                            }}
                            className="hidden"
                            aria-label={label}
                          />
                          {u.photo && (
                            <img
                              src={u.photo}
                              alt={label}
                              className="w-8 h-8 rounded-full object-cover flex-shrink-0 border-2 border-transparent"
                              onError={(e) => {
                                e.target.style.display = "none";
                              }}
                            />
                          )}
                          <div className="flex-1 min-w-0">
                            <p
                              className={`text-sm font-medium truncate ${isDark ? "text-gray-100" : "text-gray-800"}`}
                            >
                              {label}
                            </p>
                            {u.email && (
                              <p
                                className={`text-xs truncate ${isDark ? "text-gray-500" : "text-gray-500"}`}
                              >
                                {u.email}
                              </p>
                            )}
                          </div>
                          {checked && (
                            <div className="flex-shrink-0">
                              <div
                                className={`text-xs font-semibold px-2 py-1 rounded ${isDark ? "bg-purple-500/40 text-purple-200" : "bg-purple-100 text-purple-700"}`}
                              >
                                ✓
                              </div>
                            </div>
                          )}
                        </label>
                      );
                    })}
                    {users.length === 0 && (
                      <div
                        className={`col-span-2 text-center py-4 text-sm ${isDark ? "text-gray-500" : "text-gray-500"}`}
                      >
                        Aucun utilisateur trouvé
                      </div>
                    )}
                  </div>
                </div>

                {/* Avertissement si vide */}
                {allowedUsers.length === 0 && (
                  <div
                    className={`mt-3 p-3 rounded-lg text-xs ${isDark ? "bg-yellow-500/10 text-yellow-300 border border-yellow-500/30" : "bg-yellow-50 text-yellow-700 border border-yellow-200"}`}
                  >
                    ⚠️ Veuillez sélectionner UN utilisateur pour cette vente
                    unique
                  </div>
                )}
              </div>
            )}

            {/* Utilisateur propriétaire — peut laisser un avis */}
            <div>
              <label
                className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
              >
                Client propriétaire{" "}
                <span
                  className={`text-xs font-normal ${isDark ? "text-gray-500" : "text-gray-400"}`}
                >
                  (seul cet utilisateur pourra laisser un avis)
                </span>
              </label>
              <select
                name="id_user_client"
                defaultValue={productFormValues?.id_user_client ?? ""}
                className={`w-full px-3 py-2 rounded-lg border ${isDark ? "bg-[#0b0b0c] border-white/10 text-white" : "bg-white border-gray-200 text-gray-800"}`}
              >
                <option value="">— Aucun utilisateur associé —</option>
                {users.map((u) => (
                  <option key={u.id_user || u.id} value={u.id_user || u.id}>
                    {u.nickname ||
                      `${u.firstname ?? ""} ${u.lastname ?? ""}`.trim() ||
                      u.email}
                    {u.email ? ` (${u.email})` : ""}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label
                className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
              >
                Description
              </label>
              <textarea
                name="description"
                rows="3"
                defaultValue={productFormValues?.description || ""}
                className={`w-full px-3 py-2 rounded-lg border ${isDark ? "bg-[#0b0b0c] border-white/10 text-white" : "bg-white border-gray-200 text-gray-800"}`}
              />
            </div>

            {/* Champ lien du site réalisé */}
            <div>
              <label
                className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
              >
                Lien du site réalisé
              </label>
              <input
                type="text"
                name="link"
                defaultValue={productFormValues?.link || ""}
                placeholder="https://monsite.fr ou monsite.fr"
                className={`w-full px-3 py-2 rounded-lg border ${isDark ? "bg-[#0b0b0c] border-white/10 text-white" : "bg-white border-gray-200 text-gray-800"}`}
              />
              <p
                className={`text-xs mt-1 ${isDark ? "text-gray-500" : "text-gray-400"}`}
              >
                Lien vers le site réalisé (optionnel, laissez vide pour le
                retirer)
              </p>
            </div>

            <div className="flex items-center gap-3">
              <input
                type="checkbox"
                name="is_featured"
                id="is_featured"
                defaultChecked={productFormValues?.is_featured ?? true}
                className="w-4 h-4 accent-fuchsia-500 cursor-pointer"
              />
              <label
                htmlFor="is_featured"
                className={`text-sm font-medium cursor-pointer select-none ${isDark ? "text-gray-300" : "text-gray-700"}`}
              >
                Mettre en avant sur la page d'accueil
              </label>
            </div>

            <div>
              <label
                className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
              >
                Image de la réalisation
              </label>
              <div
                className={`border-2 border-dashed rounded-lg p-4 ${isDark ? "border-white/10" : "border-gray-200"}`}
              >
                <input
                  ref={fileInputRef}
                  type="file"
                  multiple
                  accept="image/*"
                  onChange={handleImageUpload}
                  required={
                    productFormMode === "create" && uploadedImages.length === 0
                  }
                  className={`w-full ${isDark ? "text-white" : "text-gray-800"}`}
                />

                <p
                  className={`mt-1 text-xs ${isDark ? "text-gray-500" : "text-gray-400"}`}
                >
                  Les images deja ajoutees restent conservees tant que vous ne
                  les retirez pas manuellement.
                </p>
                {(() => {
                  const currentImages =
                    Array.isArray(selectedProduct?.images) &&
                    selectedProduct.images.length > 0
                      ? selectedProduct.images
                          .map((img) => resolveProductImageUrl(img))
                          .filter(Boolean)
                      : [resolveProductImageUrl(selectedProduct)].filter(
                          Boolean,
                        );

                  return currentImages.length > 0 ? (
                    <div className="mt-4">
                      <p
                        className={`mb-2 text-xs font-semibold uppercase tracking-[0.18em] ${isDark ? "text-gray-400" : "text-gray-500"}`}
                      >
                        Images actuelles
                      </p>
                      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 xl:grid-cols-4">
                        {currentImages.map((url, index) => (
                          <Watermark key={`existing-${index}`}>
                            <img
                              src={url}
                              alt={`${selectedProduct?.name || "Image"} ${index + 1}`}
                              className="h-28 w-full rounded-lg object-cover"
                            />
                          </Watermark>
                        ))}
                      </div>
                    </div>
                  ) : null;
                })()}

                {imagePreviews.length > 0 ? (
                  <div className="mt-4 grid grid-cols-2 gap-3 sm:grid-cols-3 xl:grid-cols-4">
                    {imagePreviews.map((preview, index) => (
                      <div
                        key={`preview-${index}`}
                        className="relative group overflow-hidden rounded-2xl"
                      >
                        <Watermark>
                          <img
                            src={preview}
                            alt={`Aperçu ${index + 1}`}
                            className="h-28 w-full rounded-lg object-cover"
                          />
                        </Watermark>
                        <button
                          type="button"
                          onClick={() => handleRemoveUploadedImg(index)}
                          className="absolute right-2 top-2 flex h-8 w-8 items-center justify-center rounded-full border border-white/30 bg-black/55 text-white shadow-lg backdrop-blur-sm transition hover:scale-105 hover:bg-rose-600"
                          title="Retirer"
                        >
                          <X className="h-4 w-4" />
                        </button>
                      </div>
                    ))}
                  </div>
                ) : null}
              </div>
              <p
                className={`text-xs mt-2 ${isDark ? "text-gray-500" : "text-gray-400"}`}
              >
                💡 Jusqu'à 8 images compressees. La première devient l'image
                principale du produit.
              </p>
            </div>

            <div>
              {productFiles.length > 0 && (
                <p
                  className={`text-xs mt-2 ${isDark ? "text-white/60" : "text-gray-600"}`}
                >
                  {productFiles.length} fichier(s) selectionne(s)
                </p>
              )}
              {Array.isArray(selectedProduct?.downloadable_files) &&
                selectedProduct.downloadable_files.length > 0 && (
                  <div
                    className={`mt-3 rounded-lg border p-3 ${isDark ? "border-white/10 bg-white/5" : "border-gray-200 bg-gray-50"}`}
                  >
                    <p
                      className={`mb-2 text-xs font-semibold uppercase tracking-[0.18em] ${isDark ? "text-gray-400" : "text-gray-500"}`}
                    >
                      Fichiers deja associes
                    </p>
                    <div className="space-y-1.5">
                      {selectedProduct.downloadable_files.map((file, index) => (
                        <p
                          key={`${file.id || file.original_filename || index}`}
                          className={`text-xs ${isDark ? "text-white/70" : "text-gray-600"}`}
                        >
                          {file.original_filename || `Fichier ${index + 1}`}
                        </p>
                      ))}
                    </div>
                  </div>
                )}
            </div>

            <div className="flex gap-2 justify-end pt-4">
              <button
                type="button"
                onClick={() => setProductModalOpen(false)}
                className={`px-4 py-2 rounded-lg border ${isDark ? "border-white/10 hover:bg-white/5" : "border-gray-200 hover:bg-gray-50"}`}
              >
                Annuler
              </button>
              <button
                type="submit"
                className="px-4 py-2 bg-rose-500 text-white rounded-lg hover:bg-rose-600"
              >
                {productFormMode === "create" ? "Créer" : "Modifier"}
              </button>
            </div>
          </form>
        ) : (
          <div className="space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label
                  className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
                >
                  Nom
                </label>
                <p className="font-semibold">{selectedProduct?.name}</p>
              </div>
              <div>
                <label
                  className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
                >
                  Catégorie
                </label>
                <p>{selectedProduct?.category || "—"}</p>
              </div>
              {selectedProduct?.creator_name && (
                <div>
                  <label
                    className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
                  >
                    Client
                  </label>
                  <p className="font-semibold">
                    {selectedProduct.creator_name}
                  </p>
                </div>
              )}
              {(selectedProduct?.link || selectedProduct?.project_url) && (
                <div>
                  <label
                    className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
                  >
                    Lien du site
                  </label>
                  <a
                    href={selectedProduct.link || selectedProduct.project_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-violet-400 hover:underline text-sm truncate block"
                  >
                    {selectedProduct.link || selectedProduct.project_url}
                  </a>
                </div>
              )}
              <div>
                <label
                  className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
                >
                  Visible publiquement
                </label>
                <span
                  className={`px-2 py-1 rounded text-xs font-medium ${
                    selectedProduct?.is_featured
                      ? "bg-green-500/20 text-green-500"
                      : "bg-gray-500/20 text-gray-400"
                  }`}
                >
                  {selectedProduct?.is_featured ? "Oui" : "Non"}
                </span>
              </div>
            </div>
            {selectedProduct?.description && (
              <div>
                <label
                  className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
                >
                  Description
                </label>
                <p
                  className={`p-3 rounded-lg ${isDark ? "bg-[#0b0b0c] border border-white/10" : "bg-gray-50 border border-gray-200"}`}
                >
                  {selectedProduct.description}
                </p>
              </div>
            )}
            {(() => {
              const galleryImages =
                Array.isArray(selectedProduct?.images) &&
                selectedProduct.images.length > 0
                  ? selectedProduct.images
                      .map((img) => resolveProductImageUrl(img))
                      .filter(Boolean)
                  : [resolveProductImageUrl(selectedProduct)].filter(Boolean);

              if (galleryImages.length === 0) {
                return null;
              }

              const activeImage =
                galleryImages[
                  Math.min(selectedAdminGalleryImage, galleryImages.length - 1)
                ] || galleryImages[0];

              return (
                <div>
                  <label
                    className={`block text-sm font-medium mb-2 ${isDark ? "text-gray-400" : "text-gray-600"}`}
                  >
                    Galerie
                  </label>
                  <div
                    className={`overflow-hidden rounded-2xl border ${isDark ? "border-white/10 bg-[#0b0b0c]" : "border-gray-200 bg-gray-50"}`}
                  >
                    <Watermark>
                      <img
                        src={activeImage}
                        alt={selectedProduct?.name}
                        className="h-80 w-full object-cover"
                      />
                    </Watermark>
                  </div>

                  {galleryImages.length > 1 && (
                    <div className="mt-3 grid grid-cols-4 gap-3">
                      {galleryImages.slice(0, 8).map((url, index) => (
                        <button
                          key={`admin-gallery-thumb-${index}`}
                          type="button"
                          onClick={() => setSelectedAdminGalleryImage(index)}
                          className={`overflow-hidden rounded-xl border transition-all ${
                            selectedAdminGalleryImage === index
                              ? "border-rose-500 ring-2 ring-rose-500/30"
                              : isDark
                                ? "border-white/10 hover:border-white/30"
                                : "border-gray-200 hover:border-gray-300"
                          }`}
                        >
                          <Watermark>
                            <img
                              src={url}
                              alt={`${selectedProduct?.name} ${index + 1}`}
                              className="h-24 w-full object-cover"
                            />
                          </Watermark>
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              );
            })()}
            <div className="flex gap-2 justify-end pt-4 border-t">
              <button
                onClick={() => setProductModalOpen(false)}
                className={`px-4 py-2 rounded-lg border ${isDark ? "border-white/10 hover:bg-white/5" : "border-gray-200 hover:bg-gray-50"}`}
              >
                Fermer
              </button>
              <button
                onClick={() => {
                  setProductFormMode("edit");
                }}
                className="px-4 py-2 bg-rose-500 text-white rounded-lg hover:bg-rose-600"
              >
                Modifier
              </button>
            </div>
          </div>
        )}
      </ModalAdmin>

      {/* Modal Créateur */}
      <ModalAdmin
        isOpen={creatorModalOpen}
        onClose={() => setCreatorModalOpen(false)}
        title={
          creatorFormMode === "create"
            ? "Créer un créateur"
            : creatorFormMode === "edit"
              ? "Modifier le créateur"
              : "Détails du créateur"
        }
        size="md"
      >
        {creatorFormMode !== "view" ? (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              const formData = new FormData(e.target);
              handleSaveCreator({
                nickname: formData.get("nickname"),
                firstname: formData.get("firstname"),
                lastname: formData.get("lastname"),
                email: formData.get("email"),
                password: formData.get("password"),
              });
            }}
            className="space-y-4"
          >
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label
                  className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
                >
                  Pseudo <span className="text-rose-500">*</span>
                </label>
                <input
                  type="text"
                  name="nickname"
                  defaultValue={selectedCreator?.nickname || ""}
                  required
                  className={`w-full px-3 py-2 rounded-lg border ${isDark ? "bg-[#0b0b0c] border-white/10 text-white" : "bg-white border-gray-200 text-gray-800"}`}
                />
              </div>
              <div>
                <label
                  className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
                >
                  Prénom <span className="text-rose-500">*</span>
                </label>
                <input
                  type="text"
                  name="firstname"
                  defaultValue={selectedCreator?.firstname || ""}
                  required
                  className={`w-full px-3 py-2 rounded-lg border ${isDark ? "bg-[#0b0b0c] border-white/10 text-white" : "bg-white border-gray-200 text-gray-800"}`}
                />
              </div>
              <div>
                <label
                  className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
                >
                  Nom <span className="text-rose-500">*</span>
                </label>
                <input
                  type="text"
                  name="lastname"
                  defaultValue={selectedCreator?.lastname || ""}
                  required
                  className={`w-full px-3 py-2 rounded-lg border ${isDark ? "bg-[#0b0b0c] border-white/10 text-white" : "bg-white border-gray-200 text-gray-800"}`}
                />
              </div>
              <div>
                <label
                  className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
                >
                  Email <span className="text-rose-500">*</span>
                </label>
                <input
                  type="email"
                  name="email"
                  defaultValue={selectedCreator?.email || ""}
                  required
                  className={`w-full px-3 py-2 rounded-lg border ${isDark ? "bg-[#0b0b0c] border-white/10 text-white" : "bg-white border-gray-200 text-gray-800"}`}
                />
              </div>
            </div>

            <div>
              <label
                className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
              >
                Mot de passe{" "}
                {creatorFormMode === "create" && (
                  <span className="text-rose-500">*</span>
                )}
              </label>
              <input
                type="password"
                name="password"
                placeholder={
                  creatorFormMode === "edit"
                    ? "Laisser vide pour ne pas changer"
                    : ""
                }
                required={creatorFormMode === "create"}
                className={`w-full px-3 py-2 rounded-lg border ${isDark ? "bg-[#0b0b0c] border-white/10 text-white" : "bg-white border-gray-200 text-gray-800"}`}
              />
              <p
                className={`text-xs mt-1 ${isDark ? "text-gray-500" : "text-gray-400"}`}
              >
                {creatorFormMode === "create"
                  ? "Minimum 8 caractères"
                  : "Laisser vide pour conserver le mot de passe actuel"}
              </p>
            </div>

            <div>
              <label
                className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
              >
                Photo de profil
              </label>
              <div
                className={`border-2 border-dashed rounded-lg p-4 ${isDark ? "border-white/10" : "border-gray-200"}`}
              >
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleCreatorImageUpload}
                  className={`w-full ${isDark ? "text-white" : "text-gray-800"}`}
                />
                {uploadedCreatorImage && (
                  <div className="mt-3">
                    <p className="text-sm text-green-500">
                      ✓ Image sélectionnée: {uploadedCreatorImage.name}
                    </p>
                  </div>
                )}
                {selectedCreator?.picture_user && !uploadedCreatorImage && (
                  <div className="mt-3">
                    <img
                      src={selectedCreator.picture_user}
                      alt={selectedCreator.nickname}
                      className="h-32 w-32 object-cover rounded-full mx-auto"
                    />
                  </div>
                )}
              </div>
            </div>

            <div className="flex gap-2 justify-end pt-4">
              <button
                type="button"
                onClick={() => setCreatorModalOpen(false)}
                className={`px-4 py-2 rounded-lg border ${isDark ? "border-white/10 hover:bg-white/5" : "border-gray-200 hover:bg-gray-50"}`}
              >
                Annuler
              </button>
              <button
                type="submit"
                className="px-4 py-2 bg-rose-500 text-white rounded-lg hover:bg-rose-600"
              >
                {creatorFormMode === "create" ? "Créer" : "Modifier"}
              </button>
            </div>
          </form>
        ) : (
          <div className="space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label
                  className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
                >
                  Pseudo
                </label>
                <p className="font-semibold">{selectedCreator?.nickname}</p>
              </div>
              <div>
                <label
                  className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
                >
                  Nom complet
                </label>
                <p>
                  {selectedCreator?.firstname} {selectedCreator?.lastname}
                </p>
              </div>
              <div>
                <label
                  className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
                >
                  Email
                </label>
                <p>{selectedCreator?.email}</p>
              </div>
              <div>
                <label
                  className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
                >
                  Rôle
                </label>
                <span className="px-2 py-1 rounded text-xs bg-purple-500/20 text-purple-500">
                  {selectedCreator?.role}
                </span>
              </div>
              <div>
                <label
                  className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
                >
                  Date d'inscription
                </label>
                <p>
                  {selectedCreator?.created_at
                    ? new Date(selectedCreator.created_at).toLocaleDateString(
                        "fr-FR",
                      )
                    : "-"}
                </p>
              </div>
            </div>
            <div>
              <label
                className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
              >
                Statut du compte
              </label>
              <div className="flex items-center justify-between">
                <p
                  className={
                    selectedCreator.status === "active"
                      ? "text-green-500"
                      : "text-red-500"
                  }
                >
                  {selectedCreator.status === "active"
                    ? "✓ Actif"
                    : "✕ Inactif"}
                </p>
                <button
                  onClick={async () => {
                    const newStatus =
                      selectedCreator.status === "active"
                        ? "inactive"
                        : "active";
                    try {
                      await api.put(
                        `/admin/users/${selectedCreator.id_user || selectedCreator.id}`,
                        {
                          ...selectedCreator,
                          status: newStatus,
                        },
                      );
                      toast.success(
                        `Créateur ${newStatus === "active" ? "activé" : "désactivé"}`,
                      );
                      setSelectedCreator({
                        ...selectedCreator,
                        status: newStatus,
                      });
                      fetchCreators();
                    } catch (error) {
                      toast.error("Erreur lors du changement de statut");
                    }
                  }}
                  className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${
                    selectedCreator.status === "active"
                      ? "bg-red-500/10 text-red-500 hover:bg-red-500/20"
                      : "bg-green-500/10 text-green-500 hover:bg-green-500/20"
                  }`}
                >
                  {selectedCreator.status === "active"
                    ? "Désactiver"
                    : "Activer"}
                </button>
              </div>
            </div>
            {selectedCreator?.picture_user && (
              <div>
                <label
                  className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
                >
                  Photo de profil
                </label>
                <img
                  src={selectedCreator.picture_user}
                  alt={selectedCreator.nickname}
                  className="h-32 w-32 object-cover rounded-full mx-auto"
                />
              </div>
            )}
            <div className="flex gap-2 justify-end pt-4 border-t">
              <button
                onClick={() => setCreatorModalOpen(false)}
                className={`px-4 py-2 rounded-lg border ${isDark ? "border-white/10 hover:bg-white/5" : "border-gray-200 hover:bg-gray-50"}`}
              >
                Fermer
              </button>
              <button
                onClick={() => {
                  setCreatorFormMode("edit");
                }}
                className="px-4 py-2 bg-rose-500 text-white rounded-lg hover:bg-rose-600"
              >
                Modifier
              </button>
            </div>
          </div>
        )}
      </ModalAdmin>

      {/* Modal Projet */}
      <ModalAdmin
        isOpen={projectModalOpen}
        onClose={() => setProjectModalOpen(false)}
        title={
          projectFormMode === "create"
            ? "Créer un projet"
            : projectFormMode === "edit"
              ? "Modifier le projet"
              : "Détails du projet"
        }
        size="md"
      >
        {projectFormMode === "view" && selectedProject ? (
          <div className="space-y-4">
            <div>
              <label
                className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
              >
                Nom du projet
              </label>
              <p className={isDark ? "text-white" : "text-gray-800"}>
                {selectedProject.name}
              </p>
            </div>
            <div>
              <label
                className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
              >
                Client
              </label>
              <p className={isDark ? "text-white" : "text-gray-800"}>
                {selectedProject.user_name}
              </p>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label
                  className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
                >
                  Type
                </label>
                <p className={isDark ? "text-white" : "text-gray-800"}>
                  {selectedProject.type || "-"}
                </p>
              </div>
              <div>
                <label
                  className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
                >
                  Statut
                </label>
                <p className={isDark ? "text-white" : "text-gray-800"}>
                  {selectedProject.status}
                </p>
              </div>
            </div>
            <div>
              <label
                className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
              >
                Progression
              </label>
              <p className={isDark ? "text-white" : "text-gray-800"}>
                {selectedProject.progress}%
              </p>
            </div>
            <div>
              <label
                className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
              >
                Description
              </label>
              <p className={isDark ? "text-white" : "text-gray-800"}>
                {selectedProject.description || "-"}
              </p>
            </div>
          </div>
        ) : (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              const formData = new FormData(e.target);
              // Liens dynamiques
              const links = Array.from(
                document.querySelectorAll(".project-link-input"),
              )
                .map((input) => input.value.trim())
                .filter((v) => v.length > 0);

              // Images
              const images = projectImages || [];

              const projectData = {
                id_user: formData.get("id_user"),
                name: formData.get("name"),
                type: formData.get("type"),
                status: formData.get("status"),
                progress: parseInt(formData.get("progress")) || 0,
                description: formData.get("description"),
                start_date: formData.get("start_date") || null,
                end_date: formData.get("end_date") || null,
                links,
                images,
              };
              handleSaveProject(projectData);
            }}
            className="space-y-4"
          >
            {/* Liens dynamiques */}
            <div>
              <label
                className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
              >
                Liens du projet
              </label>
              {projectLinks.map((link, idx) => (
                <div key={idx} className="flex gap-2 mb-2">
                  <input
                    type="url"
                    className={`project-link-input flex-1 px-3 py-2 rounded-lg border ${isDark ? "bg-[#0b0b0c] border-white/10 text-white" : "bg-white border-gray-200 text-gray-800"}`}
                    value={link}
                    onChange={(e) => {
                      const next = [...projectLinks];
                      next[idx] = e.target.value;
                      setProjectLinks(next);
                    }}
                    placeholder="https://..."
                  />
                  <button
                    type="button"
                    onClick={() =>
                      setProjectLinks(projectLinks.filter((_, i) => i !== idx))
                    }
                    className="px-3 py-2 rounded-lg bg-rose-500 text-white hover:bg-rose-600"
                  >
                    Supprimer
                  </button>
                </div>
              ))}
              <button
                type="button"
                onClick={() => setProjectLinks([...projectLinks, ""])}
                className="px-4 py-2 rounded-lg bg-blue-500 text-white hover:bg-blue-600 mt-2"
              >
                Ajouter un lien
              </button>
            </div>

            <div>
              <label
                className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
              >
                Client *
              </label>
              <select
                name="id_user"
                defaultValue={selectedProject?.id_user || ""}
                required
                className={`w-full px-3 py-2 rounded-lg border ${isDark ? "bg-[#0b0b0c] border-white/10 text-white" : "bg-white border-gray-200 text-gray-800"}`}
              >
                <option value="">Sélectionnez un client</option>
                {users.map((u) => (
                  <option key={u.id_user} value={u.id_user}>
                    {u.name} ({u.email})
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label
                className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
              >
                Nom du projet *
              </label>
              <input
                type="text"
                name="name"
                defaultValue={selectedProject?.name || ""}
                required
                className={`w-full px-3 py-2 rounded-lg border ${isDark ? "bg-[#0b0b0c] border-white/10 text-white" : "bg-white border-gray-200 text-gray-800"}`}
              />
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label
                  className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
                >
                  Type
                </label>
                <input
                  type="text"
                  name="type"
                  defaultValue={selectedProject?.type || ""}
                  className={`w-full px-3 py-2 rounded-lg border ${isDark ? "bg-[#0b0b0c] border-white/10 text-white" : "bg-white border-gray-200 text-gray-800"}`}
                />
              </div>
              <div>
                <label
                  className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
                >
                  Statut
                </label>
                <select
                  name="status"
                  defaultValue={selectedProject?.status || "En cours"}
                  className={`w-full px-3 py-2 rounded-lg border ${isDark ? "bg-[#0b0b0c] border-white/10 text-white" : "bg-white border-gray-200 text-gray-800"}`}
                >
                  <option value="En cours">En cours</option>
                  <option value="En attente">En attente</option>
                  <option value="Terminé">Terminé</option>
                </select>
              </div>
            </div>
            <div>
              <label
                className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
              >
                Progression (%)
              </label>
              <input
                type="number"
                name="progress"
                min="0"
                max="100"
                defaultValue={selectedProject?.progress || 0}
                className={`w-full px-3 py-2 rounded-lg border ${isDark ? "bg-[#0b0b0c] border-white/10 text-white" : "bg-white border-gray-200 text-gray-800"}`}
              />
            </div>
            <div>
              <label
                className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
              >
                Description
              </label>
              <textarea
                name="description"
                rows="4"
                defaultValue={selectedProject?.description || ""}
                className={`w-full px-3 py-2 rounded-lg border resize-none ${isDark ? "bg-[#0b0b0c] border-white/10 text-white" : "bg-white border-gray-200 text-gray-800"}`}
              />
            </div>
            <div className="flex gap-2 justify-end pt-4 border-t">
              <button
                type="button"
                onClick={() => setProjectModalOpen(false)}
                className={`px-4 py-2 rounded-lg border ${isDark ? "border-white/10 hover:bg-white/5" : "border-gray-200 hover:bg-gray-50"}`}
              >
                Annuler
              </button>
              <button
                type="submit"
                className="px-4 py-2 bg-rose-500 text-white rounded-lg hover:bg-rose-600"
              >
                {projectFormMode === "create" ? "Créer" : "Enregistrer"}
              </button>
            </div>
          </form>
        )}
      </ModalAdmin>

      {/* Modal Catégories */}
      <ModalAdmin
        isOpen={categoryModalOpen}
        onClose={() => {
          setCategoryModalOpen(false);
          setSelectedCategoryData(null);
        }}
        title={
          categoryFormMode === "create"
            ? "Ajouter une catégorie"
            : "Modifier la catégorie"
        }
      >
        <form
          onSubmit={(e) => {
            e.preventDefault();
            const formData = new FormData(e.target);
            handleSaveCategory({
              name: formData.get("name"),
              slug: formData.get("slug"),
            });
          }}
          className="space-y-4"
        >
          <div>
            <label
              className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
            >
              Nom de la catégorie <span className="text-rose-500">*</span>
            </label>
            <input
              type="text"
              name="name"
              defaultValue={
                selectedCategoryData?.name ||
                selectedCategoryData?.name_category ||
                ""
              }
              required
              className={`w-full px-3 py-2 rounded-lg border ${isDark ? "bg-[#0b0b0c] border-white/10 text-white" : "bg-white border-gray-200 text-gray-800"}`}
              placeholder="Ex: Logos, Bannières, Illustrations..."
            />
          </div>

          <div>
            <label
              className={`block text-sm font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}
            >
              Slug{" "}
              <span className="text-gray-400 text-xs">
                (optionnel, généré automatiquement si vide)
              </span>
            </label>
            <input
              type="text"
              name="slug"
              defaultValue={selectedCategoryData?.slug || ""}
              className={`w-full px-3 py-2 rounded-lg border ${isDark ? "bg-[#0b0b0c] border-white/10 text-white" : "bg-white border-gray-200 text-gray-800"}`}
              placeholder="Ex: logos, bannieres..."
            />
            <p
              className={`text-xs mt-1 ${isDark ? "text-gray-500" : "text-gray-400"}`}
            >
              Le slug est utilisé dans les URLs. Laissez vide pour génération
              automatique.
            </p>
          </div>

          <div className="flex gap-2 justify-end pt-4 border-t">
            <button
              type="button"
              onClick={() => setCategoryModalOpen(false)}
              className={`px-4 py-2 rounded-lg border ${isDark ? "border-white/10 hover:bg-white/5" : "border-gray-200 hover:bg-gray-50"}`}
            >
              Annuler
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-rose-500 text-white rounded-lg hover:bg-rose-600"
            >
              {categoryFormMode === "create" ? "Créer" : "Enregistrer"}
            </button>
          </div>
        </form>
      </ModalAdmin>
    </div>
  );
}

export default Dashboard;
